export const RECIPES = {
    // === EARTH DELVING (Mining) ===
    mine_pyrite: {
        id: 'mine_pyrite',
        skill: 'mining',
        levelReq: 1,
        name: 'Pyrite Vein',
        inputs: [],
        outputItemId: 'pyrite_ore',
        outputQuantity: 1,
        xp: 2,
        intervalSeconds: 3.0,
        rareFinds: [{ itemId: 'pet_rocky', chance: 1 / 45000 }],
    },
    mine_galena: {
        id: 'mine_galena',
        skill: 'mining',
        levelReq: 1,
        name: 'Galena Vein',
        inputs: [],
        outputItemId: 'galena_ore',
        outputQuantity: 1,
        xp: 3,
        intervalSeconds: 3.0,
        rareFinds: [{ itemId: 'pet_rocky', chance: 1 / 45000 }],
    },
    mine_cold_iron: {
        id: 'mine_cold_iron',
        skill: 'mining',
        levelReq: 15,
        name: 'Cold Iron Seam',
        inputs: [],
        outputItemId: 'cold_iron_ore',
        outputQuantity: 1,
        xp: 5,
        intervalSeconds: 3.6,
        rareFinds: [
            { itemId: 'uncut_celestial_gem', chance: 1 / 2000 },
            { itemId: 'pet_rocky', chance: 1 / 40000 },
        ],
    },
    mine_quicksilver: {
        id: 'mine_quicksilver',
        skill: 'mining',
        levelReq: 30,
        name: 'Quicksilver Lode',
        inputs: [],
        outputItemId: 'quicksilver_ore',
        outputQuantity: 1,
        xp: 9,
        intervalSeconds: 4.2,
        rareFinds: [
            { itemId: 'uncut_celestial_gem', chance: 1 / 1000 },
            { itemId: 'pet_rocky', chance: 1 / 35000 },
        ],
    },
    mine_nethercoal: {
        id: 'mine_nethercoal',
        skill: 'mining',
        levelReq: 40,
        name: 'Nethercoal Fissure',
        inputs: [],
        outputItemId: 'nethercoal',
        outputQuantity: 1,
        xp: 14,
        intervalSeconds: 4.8,
        rareFinds: [
            { itemId: 'uncut_celestial_gem', chance: 1 / 1000 },
            { itemId: 'pet_rocky', chance: 1 / 30000 },
        ],
    },
    mine_solar_aurum: {
        id: 'mine_solar_aurum',
        skill: 'mining',
        levelReq: 55,
        name: 'Solar Aurum Lode',
        inputs: [],
        outputItemId: 'solar_aurum_ore',
        outputQuantity: 1,
        xp: 22,
        intervalSeconds: 5.4,
        rareFinds: [
            { itemId: 'uncut_celestial_gem', chance: 1 / 500 },
            { itemId: 'pet_rocky', chance: 1 / 25000 },
        ],
    },
    mine_azurite: {
        id: 'mine_azurite',
        skill: 'mining',
        levelReq: 65,
        name: 'Azurite Vein',
        inputs: [],
        outputItemId: 'azurite_ore',
        outputQuantity: 1,
        xp: 37,
        intervalSeconds: 6.6,
        rareFinds: [
            { itemId: 'uncut_celestial_gem', chance: 1 / 333 },
            { itemId: 'pet_rocky', chance: 1 / 18000 },
        ],
    },
    mine_starfall: {
        id: 'mine_starfall',
        skill: 'mining',
        levelReq: 85,
        name: 'Starfall Core',
        inputs: [],
        outputItemId: 'starfall_ore',
        outputQuantity: 1,
        xp: 59,
        intervalSeconds: 7.8,
        rareFinds: [
            { itemId: 'uncut_celestial_gem', chance: 1 / 200 },
            { itemId: 'pet_rocky', chance: 1 / 12000 },
        ],
    },
    // === TIMBERCRAFT (Woodcutting) ===
    chop_ashwood: {
        id: 'chop_ashwood',
        skill: 'woodcutting',
        levelReq: 1,
        name: 'Ashwood Copse',
        inputs: [],
        outputItemId: 'ashwood_timber',
        outputQuantity: 1,
        xp: 3,
        intervalSeconds: 3.0,
        rareFinds: [
            { itemId: 'earthtuber_seed', chance: 0.013 },
            { itemId: 'pet_treant', chance: 1 / 45000 },
        ],
    },
    chop_oak: {
        id: 'chop_oak',
        skill: 'woodcutting',
        levelReq: 15,
        name: 'Whispering Oak',
        inputs: [],
        outputItemId: 'whispering_oak',
        outputQuantity: 1,
        xp: 7,
        intervalSeconds: 3.6,
        rareFinds: [
            { itemId: 'glowshroom_spore', chance: 1 / 120 },
            { itemId: 'pet_treant', chance: 1 / 40000 },
        ],
    },
    chop_willow: {
        id: 'chop_willow',
        skill: 'woodcutting',
        levelReq: 30,
        name: 'Weeping Willow',
        inputs: [],
        outputItemId: 'weeping_willow',
        outputQuantity: 1,
        xp: 11,
        intervalSeconds: 4.2,
        rareFinds: [
            { itemId: 'deep_radish_seed', chance: 1 / 180 },
            { itemId: 'pet_treant', chance: 1 / 35000 },
        ],
    },
    chop_bloodwood: {
        id: 'chop_bloodwood',
        skill: 'woodcutting',
        levelReq: 45,
        name: 'Bloodwood Grove',
        inputs: [],
        outputItemId: 'bloodwood_timber',
        outputQuantity: 1,
        xp: 18,
        intervalSeconds: 4.8,
        rareFinds: [
            { itemId: 'bramble_mandrake_seed', chance: 1 / 260 },
            { itemId: 'pet_treant', chance: 1 / 28000 },
        ],
    },
    chop_ghostwood: {
        id: 'chop_ghostwood',
        skill: 'woodcutting',
        levelReq: 60,
        name: 'Ghostwood Spirit Yew',
        inputs: [],
        outputItemId: 'ghostwood_timber',
        outputQuantity: 1,
        xp: 29,
        intervalSeconds: 6.0,
        rareFinds: [
            { itemId: 'nether_gourd_seed', chance: 1 / 360 },
            { itemId: 'pet_treant', chance: 1 / 20000 },
        ],
    },
    chop_starlight: {
        id: 'chop_starlight',
        skill: 'woodcutting',
        levelReq: 75,
        name: 'Aetherial Starlight Tree',
        inputs: [],
        outputItemId: 'starlight_timber',
        outputQuantity: 1,
        xp: 48,
        intervalSeconds: 7.2,
        rareFinds: [
            { itemId: 'sunfire_pod', chance: 1 / 450 },
            { itemId: 'pet_treant', chance: 1 / 12000 },
        ],
    },
    // === TIDECALLING (Fishing) ===
    fish_prawn: {
        id: 'fish_prawn',
        skill: 'fishing',
        levelReq: 1,
        name: 'Shallow Shallows (Tide Prawn)',
        inputs: [],
        outputItemId: 'tide_prawn',
        outputQuantity: 1,
        xp: 2,
        intervalSeconds: 3.0,
        rareFinds: [{ itemId: 'pet_otter', chance: 1 / 45000 }],
    },
    fish_minnow: {
        id: 'fish_minnow',
        skill: 'fishing',
        levelReq: 5,
        name: 'Glimmer Pool (Minnow)',
        inputs: [],
        outputItemId: 'glimmer_minnow',
        outputQuantity: 1,
        xp: 3,
        intervalSeconds: 3.0,
        rareFinds: [{ itemId: 'pet_otter', chance: 1 / 45000 }],
    },
    fish_trout: {
        id: 'fish_trout',
        skill: 'fishing',
        levelReq: 20,
        name: 'River Eddy (Silverspeck Trout)',
        inputs: [],
        outputItemId: 'silverspeck_trout',
        outputQuantity: 1,
        xp: 7,
        intervalSeconds: 3.6,
        rareFinds: [{ itemId: 'pet_otter', chance: 1 / 40000 }],
    },
    fish_salmon: {
        id: 'fish_salmon',
        skill: 'fishing',
        levelReq: 30,
        name: 'Sunlit Rapid (Solar Crest)',
        inputs: [],
        outputItemId: 'solar_crest_salmon',
        outputQuantity: 1,
        xp: 11,
        intervalSeconds: 4.2,
        rareFinds: [{ itemId: 'pet_otter', chance: 1 / 35000 }],
    },
    fish_albacore: {
        id: 'fish_albacore',
        skill: 'fishing',
        levelReq: 45,
        name: 'Outer Bay (Deepsea Albacore)',
        inputs: [],
        outputItemId: 'deepsea_albacore',
        outputQuantity: 1,
        xp: 17,
        intervalSeconds: 4.8,
        rareFinds: [{ itemId: 'pet_otter', chance: 1 / 28000 }],
    },
    fish_ironpincer: {
        id: 'fish_ironpincer',
        skill: 'fishing',
        levelReq: 60,
        name: 'Sunken Reef (Ironpincer)',
        inputs: [],
        outputItemId: 'ironpincer_crustacean',
        outputQuantity: 1,
        xp: 28,
        intervalSeconds: 6.0,
        rareFinds: [{ itemId: 'pet_otter', chance: 1 / 20000 }],
    },
    fish_bladefin: {
        id: 'fish_bladefin',
        skill: 'fishing',
        levelReq: 75,
        name: 'The Trench (Bladefin Sovereign)',
        inputs: [],
        outputItemId: 'bladefin_sovereign',
        outputQuantity: 1,
        xp: 44,
        intervalSeconds: 6.6,
        rareFinds: [{ itemId: 'pet_otter', chance: 1 / 14000 }],
    },
    fish_mawshark: {
        id: 'fish_mawshark',
        skill: 'fishing',
        levelReq: 90,
        name: 'Abyssal Depth (Mawshark)',
        inputs: [],
        outputItemId: 'abyssal_mawshark',
        outputQuantity: 1,
        xp: 60,
        intervalSeconds: 7.8,
        rareFinds: [{ itemId: 'pet_otter', chance: 1 / 9000 }],
    },
    // === RUNE-FORGING (Ingots) ===
    smelt_dawnburn_ingot: {
        id: 'smelt_dawnburn_ingot',
        skill: 'smithing',
        levelReq: 1,
        name: 'Dawnburn Ingot',
        inputs: [
            { itemId: 'pyrite_ore', quantity: 1 },
            { itemId: 'galena_ore', quantity: 1 },
        ],
        outputItemId: 'dawnburn_ingot',
        outputQuantity: 1,
        xp: 5,
        intervalSeconds: 2.4,
    },
    smelt_cold_iron_ingot: {
        id: 'smelt_cold_iron_ingot',
        skill: 'smithing',
        levelReq: 15,
        name: 'Cold Iron Ingot',
        inputs: [{ itemId: 'cold_iron_ore', quantity: 1 }],
        outputItemId: 'cold_iron_ingot',
        outputQuantity: 1,
        xp: 8,
        intervalSeconds: 2.4,
    },
    smelt_steel_ingot: {
        id: 'smelt_steel_ingot',
        skill: 'smithing',
        levelReq: 30,
        name: 'Steel Ingot',
        inputs: [
            { itemId: 'cold_iron_ore', quantity: 1 },
            { itemId: 'nethercoal', quantity: 2 },
        ],
        outputItemId: 'steel_ingot',
        outputQuantity: 1,
        xp: 20,
        intervalSeconds: 2.4,
    },
    smelt_solar_aurum_ingot: {
        id: 'smelt_solar_aurum_ingot',
        skill: 'smithing',
        levelReq: 50,
        name: 'Solar Aurum Ingot',
        inputs: [
            { itemId: 'solar_aurum_ore', quantity: 1 },
            { itemId: 'nethercoal', quantity: 1 },
        ],
        outputItemId: 'solar_aurum_ingot',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 2.4,
    },
    smelt_azurite_ingot: {
        id: 'smelt_azurite_ingot',
        skill: 'smithing',
        levelReq: 60,
        name: 'Azurite Ingot',
        inputs: [
            { itemId: 'azurite_ore', quantity: 1 },
            { itemId: 'nethercoal', quantity: 3 },
        ],
        outputItemId: 'azurite_ingot',
        outputQuantity: 1,
        xp: 50,
        intervalSeconds: 2.4,
    },
    smelt_astralite_ingot: {
        id: 'smelt_astralite_ingot',
        skill: 'smithing',
        levelReq: 85,
        name: 'Astralite Ingot',
        inputs: [
            { itemId: 'starfall_ore', quantity: 1 },
            { itemId: 'nethercoal', quantity: 4 },
        ],
        outputItemId: 'astralite_ingot',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 2.4,
    },
    // --- Smithing: Arms, Armaments & Tools ---
    forge_dawnburn_blade: {
        id: 'forge_dawnburn_blade',
        skill: 'smithing',
        levelReq: 1,
        name: 'Dawnburn Blade',
        inputs: [{ itemId: 'dawnburn_ingot', quantity: 2 }],
        outputItemId: 'dawnburn_blade',
        outputQuantity: 1,
        xp: 15,
        intervalSeconds: 3.0,
    },
    forge_cold_iron_blade: {
        id: 'forge_cold_iron_blade',
        skill: 'smithing',
        levelReq: 15,
        name: 'Cold Iron Blade',
        inputs: [{ itemId: 'cold_iron_ingot', quantity: 2 }],
        outputItemId: 'cold_iron_blade',
        outputQuantity: 1,
        xp: 30,
        intervalSeconds: 3.4,
    },
    forge_steel_blade: {
        id: 'forge_steel_blade',
        skill: 'smithing',
        levelReq: 30,
        name: 'Steel Blade',
        inputs: [{ itemId: 'steel_ingot', quantity: 2 }],
        outputItemId: 'steel_blade',
        outputQuantity: 1,
        xp: 70,
        intervalSeconds: 4.0,
    },
    forge_azurite_blade: {
        id: 'forge_azurite_blade',
        skill: 'smithing',
        levelReq: 60,
        name: 'Azurite Blade',
        inputs: [{ itemId: 'azurite_ingot', quantity: 2 }],
        outputItemId: 'azurite_blade',
        outputQuantity: 1,
        xp: 160,
        intervalSeconds: 4.8,
    },
    forge_astralite_blade: {
        id: 'forge_astralite_blade',
        skill: 'smithing',
        levelReq: 85,
        name: 'Astralite Blade',
        inputs: [{ itemId: 'astralite_ingot', quantity: 2 }],
        outputItemId: 'astralite_blade',
        outputQuantity: 1,
        xp: 320,
        intervalSeconds: 5.6,
    },
    forge_primordial_titan_blade: {
        id: 'forge_primordial_titan_blade',
        skill: 'smithing',
        levelReq: 97,
        name: 'Primordial Titan Blade',
        inputs: [{ itemId: 'titan_shard', quantity: 2 }, { itemId: 'astralite_ingot', quantity: 2 }],
        outputItemId: 'primordial_titan_blade',
        outputQuantity: 1,
        xp: 650,
        intervalSeconds: 7.0,
    },
    forge_dawnburn_greatsword: {
        id: 'forge_dawnburn_greatsword',
        skill: 'smithing',
        levelReq: 1,
        name: 'Dawnburn Greatsword',
        inputs: [{ itemId: 'dawnburn_ingot', quantity: 3 }],
        outputItemId: 'dawnburn_greatsword',
        outputQuantity: 1,
        xp: 25,
        intervalSeconds: 3.6,
    },
    forge_cold_iron_greatsword: {
        id: 'forge_cold_iron_greatsword',
        skill: 'smithing',
        levelReq: 20,
        name: 'Cold Iron Greatsword',
        inputs: [{ itemId: 'cold_iron_ingot', quantity: 3 }],
        outputItemId: 'cold_iron_greatsword',
        outputQuantity: 1,
        xp: 45,
        intervalSeconds: 4.0,
    },
    forge_steel_greatsword: {
        id: 'forge_steel_greatsword',
        skill: 'smithing',
        levelReq: 35,
        name: 'Steel Greatsword',
        inputs: [{ itemId: 'steel_ingot', quantity: 3 }],
        outputItemId: 'steel_greatsword',
        outputQuantity: 1,
        xp: 100,
        intervalSeconds: 4.6,
    },
    forge_azurite_greatsword: {
        id: 'forge_azurite_greatsword',
        skill: 'smithing',
        levelReq: 65,
        name: 'Azurite Greatsword',
        inputs: [{ itemId: 'azurite_ingot', quantity: 3 }],
        outputItemId: 'azurite_greatsword',
        outputQuantity: 1,
        xp: 220,
        intervalSeconds: 5.4,
    },
    forge_astralite_greatsword: {
        id: 'forge_astralite_greatsword',
        skill: 'smithing',
        levelReq: 88,
        name: 'Astralite Greatsword',
        inputs: [{ itemId: 'astralite_ingot', quantity: 3 }],
        outputItemId: 'astralite_greatsword',
        outputQuantity: 1,
        xp: 450,
        intervalSeconds: 6.2,
    },
    forge_primordial_greatsword: {
        id: 'forge_primordial_greatsword',
        skill: 'smithing',
        levelReq: 99,
        name: 'Primordial Greatsword',
        inputs: [{ itemId: 'titan_shard', quantity: 3 }, { itemId: 'astralite_ingot', quantity: 3 }],
        outputItemId: 'primordial_greatsword',
        outputQuantity: 1,
        xp: 950,
        intervalSeconds: 8.0,
    },
    forge_dawnburn_shield: {
        id: 'forge_dawnburn_shield',
        skill: 'smithing',
        levelReq: 3,
        name: 'Dawnburn Shield',
        inputs: [{ itemId: 'dawnburn_ingot', quantity: 2 }],
        outputItemId: 'dawnburn_shield',
        outputQuantity: 1,
        xp: 18,
        intervalSeconds: 3.2,
    },
    forge_cold_iron_shield: {
        id: 'forge_cold_iron_shield',
        skill: 'smithing',
        levelReq: 18,
        name: 'Cold Iron Shield',
        inputs: [{ itemId: 'cold_iron_ingot', quantity: 2 }],
        outputItemId: 'cold_iron_shield',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 3.6,
    },
    forge_steel_shield: {
        id: 'forge_steel_shield',
        skill: 'smithing',
        levelReq: 33,
        name: 'Steel Shield',
        inputs: [{ itemId: 'steel_ingot', quantity: 2 }],
        outputItemId: 'steel_shield',
        outputQuantity: 1,
        xp: 75,
        intervalSeconds: 4.2,
    },
    forge_azurite_shield: {
        id: 'forge_azurite_shield',
        skill: 'smithing',
        levelReq: 63,
        name: 'Azurite Shield',
        inputs: [{ itemId: 'azurite_ingot', quantity: 2 }],
        outputItemId: 'azurite_shield',
        outputQuantity: 1,
        xp: 170,
        intervalSeconds: 5.0,
    },
    forge_astralite_shield: {
        id: 'forge_astralite_shield',
        skill: 'smithing',
        levelReq: 86,
        name: 'Astralite Shield',
        inputs: [{ itemId: 'astralite_ingot', quantity: 2 }],
        outputItemId: 'astralite_shield',
        outputQuantity: 1,
        xp: 340,
        intervalSeconds: 6.0,
    },
    forge_primordial_shield: {
        id: 'forge_primordial_shield',
        skill: 'smithing',
        levelReq: 98,
        name: 'Primordial Shield',
        inputs: [{ itemId: 'titan_shard', quantity: 2 }, { itemId: 'astralite_ingot', quantity: 2 }],
        outputItemId: 'primordial_shield',
        outputQuantity: 1,
        xp: 750,
        intervalSeconds: 7.2,
    },
    forge_dawnburn_helm: {
        id: 'forge_dawnburn_helm',
        skill: 'smithing',
        levelReq: 4,
        name: 'Dawnburn Helm',
        inputs: [{ itemId: 'dawnburn_ingot', quantity: 2 }],
        outputItemId: 'dawnburn_helm',
        outputQuantity: 1,
        xp: 20,
        intervalSeconds: 3.2,
    },
    forge_steel_helm: {
        id: 'forge_steel_helm',
        skill: 'smithing',
        levelReq: 34,
        name: 'Steel Full Helm',
        inputs: [{ itemId: 'steel_ingot', quantity: 2 }],
        outputItemId: 'steel_helm',
        outputQuantity: 1,
        xp: 80,
        intervalSeconds: 4.2,
    },
    forge_azurite_helm: {
        id: 'forge_azurite_helm',
        skill: 'smithing',
        levelReq: 64,
        name: 'Azurite Visor Helm',
        inputs: [{ itemId: 'azurite_ingot', quantity: 2 }],
        outputItemId: 'azurite_helm',
        outputQuantity: 1,
        xp: 180,
        intervalSeconds: 5.0,
    },
    forge_astralite_helm: {
        id: 'forge_astralite_helm',
        skill: 'smithing',
        levelReq: 87,
        name: 'Astralite Crown',
        inputs: [{ itemId: 'astralite_ingot', quantity: 2 }],
        outputItemId: 'astralite_helm',
        outputQuantity: 1,
        xp: 360,
        intervalSeconds: 6.0,
    },
    forge_primordial_helm: {
        id: 'forge_primordial_helm',
        skill: 'smithing',
        levelReq: 98,
        name: 'Primordial Horned Mask',
        inputs: [{ itemId: 'titan_shard', quantity: 2 }, { itemId: 'astralite_ingot', quantity: 2 }],
        outputItemId: 'primordial_helm',
        outputQuantity: 1,
        xp: 800,
        intervalSeconds: 7.2,
    },
    forge_dawnburn_plate: {
        id: 'forge_dawnburn_plate',
        skill: 'smithing',
        levelReq: 8,
        name: 'Dawnburn Plate',
        inputs: [{ itemId: 'dawnburn_ingot', quantity: 5 }],
        outputItemId: 'dawnburn_plate',
        outputQuantity: 1,
        xp: 45,
        intervalSeconds: 4.5,
    },
    forge_cold_iron_plate: {
        id: 'forge_cold_iron_plate',
        skill: 'smithing',
        levelReq: 22,
        name: 'Cold Iron Plate',
        inputs: [{ itemId: 'cold_iron_ingot', quantity: 5 }],
        outputItemId: 'cold_iron_plate',
        outputQuantity: 1,
        xp: 75,
        intervalSeconds: 5.0,
    },
    forge_steel_plate: {
        id: 'forge_steel_plate',
        skill: 'smithing',
        levelReq: 38,
        name: 'Steel Plate',
        inputs: [{ itemId: 'steel_ingot', quantity: 5 }],
        outputItemId: 'steel_plate',
        outputQuantity: 1,
        xp: 160,
        intervalSeconds: 5.5,
    },
    forge_azurite_plate: {
        id: 'forge_azurite_plate',
        skill: 'smithing',
        levelReq: 68,
        name: 'Azurite Plate',
        inputs: [{ itemId: 'azurite_ingot', quantity: 5 }],
        outputItemId: 'azurite_plate',
        outputQuantity: 1,
        xp: 360,
        intervalSeconds: 6.5,
    },
    forge_astralite_plate: {
        id: 'forge_astralite_plate',
        skill: 'smithing',
        levelReq: 90,
        name: 'Astralite Plate',
        inputs: [{ itemId: 'astralite_ingot', quantity: 5 }],
        outputItemId: 'astralite_plate',
        outputQuantity: 1,
        xp: 700,
        intervalSeconds: 7.5,
    },
    forge_primordial_plate: {
        id: 'forge_primordial_plate',
        skill: 'smithing',
        levelReq: 99,
        name: 'Primordial Plate',
        inputs: [{ itemId: 'titan_shard', quantity: 5 }, { itemId: 'astralite_ingot', quantity: 5 }],
        outputItemId: 'primordial_plate',
        outputQuantity: 1,
        xp: 1500,
        intervalSeconds: 9.0,
    },
    forge_dawnburn_legs: {
        id: 'forge_dawnburn_legs',
        skill: 'smithing',
        levelReq: 6,
        name: 'Dawnburn Greaves',
        inputs: [{ itemId: 'dawnburn_ingot', quantity: 3 }],
        outputItemId: 'dawnburn_legs',
        outputQuantity: 1,
        xp: 30,
        intervalSeconds: 3.8,
    },
    forge_cold_iron_legs: {
        id: 'forge_cold_iron_legs',
        skill: 'smithing',
        levelReq: 20,
        name: 'Cold Iron Greaves',
        inputs: [{ itemId: 'cold_iron_ingot', quantity: 3 }],
        outputItemId: 'cold_iron_legs',
        outputQuantity: 1,
        xp: 50,
        intervalSeconds: 4.2,
    },
    forge_steel_legs: {
        id: 'forge_steel_legs',
        skill: 'smithing',
        levelReq: 36,
        name: 'Steel Greaves',
        inputs: [{ itemId: 'steel_ingot', quantity: 3 }],
        outputItemId: 'steel_legs',
        outputQuantity: 1,
        xp: 100,
        intervalSeconds: 4.8,
    },
    forge_azurite_legs: {
        id: 'forge_azurite_legs',
        skill: 'smithing',
        levelReq: 66,
        name: 'Azurite Greaves',
        inputs: [{ itemId: 'azurite_ingot', quantity: 3 }],
        outputItemId: 'azurite_legs',
        outputQuantity: 1,
        xp: 230,
        intervalSeconds: 5.8,
    },
    forge_astralite_legs: {
        id: 'forge_astralite_legs',
        skill: 'smithing',
        levelReq: 89,
        name: 'Astralite Greaves',
        inputs: [{ itemId: 'astralite_ingot', quantity: 3 }],
        outputItemId: 'astralite_legs',
        outputQuantity: 1,
        xp: 460,
        intervalSeconds: 6.8,
    },
    forge_primordial_legs: {
        id: 'forge_primordial_legs',
        skill: 'smithing',
        levelReq: 99,
        name: 'Primordial Greaves',
        inputs: [{ itemId: 'titan_shard', quantity: 3 }, { itemId: 'astralite_ingot', quantity: 3 }],
        outputItemId: 'primordial_legs',
        outputQuantity: 1,
        xp: 950,
        intervalSeconds: 7.8,
    },
    forge_pickaxe_cold_iron: {
        id: 'forge_pickaxe_cold_iron',
        skill: 'smithing',
        levelReq: 20,
        name: 'Cold Iron Pickaxe',
        inputs: [{ itemId: 'cold_iron_ingot', quantity: 2 }, { itemId: 'whispering_oak', quantity: 1 }],
        outputItemId: 'rune_pickaxe_cold_iron',
        outputQuantity: 1,
        xp: 50,
        intervalSeconds: 4.0,
    },
    forge_pickaxe_steel: {
        id: 'forge_pickaxe_steel',
        skill: 'smithing',
        levelReq: 35,
        name: 'Steel Pickaxe',
        inputs: [{ itemId: 'steel_ingot', quantity: 2 }, { itemId: 'weeping_willow', quantity: 1 }],
        outputItemId: 'rune_pickaxe_steel',
        outputQuantity: 1,
        xp: 95,
        intervalSeconds: 4.5,
    },
    forge_pickaxe_azurite: {
        id: 'forge_pickaxe_azurite',
        skill: 'smithing',
        levelReq: 65,
        name: 'Azurite Pickaxe',
        inputs: [{ itemId: 'azurite_ingot', quantity: 2 }, { itemId: 'bloodwood_timber', quantity: 1 }],
        outputItemId: 'rune_pickaxe_azurite',
        outputQuantity: 1,
        xp: 220,
        intervalSeconds: 5.5,
    },
    forge_pickaxe_astralite: {
        id: 'forge_pickaxe_astralite',
        skill: 'smithing',
        levelReq: 88,
        name: 'Astralite Pickaxe',
        inputs: [{ itemId: 'astralite_ingot', quantity: 2 }, { itemId: 'starlight_timber', quantity: 1 }],
        outputItemId: 'rune_pickaxe_astralite',
        outputQuantity: 1,
        xp: 450,
        intervalSeconds: 6.5,
    },
    forge_axe_cold_iron: {
        id: 'forge_axe_cold_iron',
        skill: 'smithing',
        levelReq: 20,
        name: 'Cold Iron Wood Axe',
        inputs: [{ itemId: 'cold_iron_ingot', quantity: 2 }, { itemId: 'whispering_oak', quantity: 1 }],
        outputItemId: 'rune_axe_cold_iron',
        outputQuantity: 1,
        xp: 50,
        intervalSeconds: 4.0,
    },
    forge_axe_steel: {
        id: 'forge_axe_steel',
        skill: 'smithing',
        levelReq: 35,
        name: 'Steel Wood Axe',
        inputs: [{ itemId: 'steel_ingot', quantity: 2 }, { itemId: 'weeping_willow', quantity: 1 }],
        outputItemId: 'rune_axe_steel',
        outputQuantity: 1,
        xp: 95,
        intervalSeconds: 4.5,
    },
    forge_axe_azurite: {
        id: 'forge_axe_azurite',
        skill: 'smithing',
        levelReq: 65,
        name: 'Azurite Wood Axe',
        inputs: [{ itemId: 'azurite_ingot', quantity: 2 }, { itemId: 'bloodwood_timber', quantity: 1 }],
        outputItemId: 'rune_axe_azurite',
        outputQuantity: 1,
        xp: 220,
        intervalSeconds: 5.5,
    },
    forge_axe_astralite: {
        id: 'forge_axe_astralite',
        skill: 'smithing',
        levelReq: 88,
        name: 'Astralite Wood Axe',
        inputs: [{ itemId: 'astralite_ingot', quantity: 2 }, { itemId: 'starlight_timber', quantity: 1 }],
        outputItemId: 'rune_axe_astralite',
        outputQuantity: 1,
        xp: 450,
        intervalSeconds: 6.5,
    },
    // === HEARTHCRAFT (Cooking) ===
    cook_prawn: {
        id: 'cook_prawn',
        skill: 'cooking',
        levelReq: 1,
        name: 'Smoked Prawn',
        inputs: [{ itemId: 'tide_prawn', quantity: 1 }],
        outputItemId: 'smoked_prawn',
        outputQuantity: 1,
        xp: 4,
        intervalSeconds: 2.4,
        burnRateAtLevel: { startLevel: 1, startBurnRate: 0.3, stopBurnLevel: 26 },
    },
    cook_minnow: {
        id: 'cook_minnow',
        skill: 'cooking',
        levelReq: 5,
        name: 'Crisped Minnow',
        inputs: [{ itemId: 'glimmer_minnow', quantity: 1 }],
        outputItemId: 'crisped_minnow',
        outputQuantity: 1,
        xp: 5,
        intervalSeconds: 2.4,
        burnRateAtLevel: { startLevel: 5, startBurnRate: 0.3, stopBurnLevel: 30 },
    },
    cook_trout: {
        id: 'cook_trout',
        skill: 'cooking',
        levelReq: 20,
        name: 'Seared Trout',
        inputs: [{ itemId: 'silverspeck_trout', quantity: 1 }],
        outputItemId: 'seared_trout',
        outputQuantity: 1,
        xp: 10,
        intervalSeconds: 2.4,
        burnRateAtLevel: { startLevel: 20, startBurnRate: 0.3, stopBurnLevel: 45 },
    },
    cook_salmon: {
        id: 'cook_salmon',
        skill: 'cooking',
        levelReq: 30,
        name: 'Poached Solar Crest',
        inputs: [{ itemId: 'solar_crest_salmon', quantity: 1 }],
        outputItemId: 'poached_solar_crest',
        outputQuantity: 1,
        xp: 14,
        intervalSeconds: 2.4,
        burnRateAtLevel: { startLevel: 30, startBurnRate: 0.3, stopBurnLevel: 55 },
    },
    cook_albacore: {
        id: 'cook_albacore',
        skill: 'cooking',
        levelReq: 45,
        name: 'Glazed Albacore',
        inputs: [{ itemId: 'deepsea_albacore', quantity: 1 }],
        outputItemId: 'glazed_albacore',
        outputQuantity: 1,
        xp: 22,
        intervalSeconds: 2.4,
        burnRateAtLevel: { startLevel: 45, startBurnRate: 0.3, stopBurnLevel: 70 },
    },
    cook_ironpincer: {
        id: 'cook_ironpincer',
        skill: 'cooking',
        levelReq: 60,
        name: 'Broiled Ironpincer',
        inputs: [{ itemId: 'ironpincer_crustacean', quantity: 1 }],
        outputItemId: 'broiled_ironpincer',
        outputQuantity: 1,
        xp: 36,
        intervalSeconds: 2.4,
        burnRateAtLevel: { startLevel: 60, startBurnRate: 0.3, stopBurnLevel: 85 },
    },
    cook_bladefin: {
        id: 'cook_bladefin',
        skill: 'cooking',
        levelReq: 75,
        name: 'Roast Bladefin',
        inputs: [{ itemId: 'bladefin_sovereign', quantity: 1 }],
        outputItemId: 'roast_bladefin',
        outputQuantity: 1,
        xp: 59,
        intervalSeconds: 2.4,
        burnRateAtLevel: { startLevel: 75, startBurnRate: 0.3, stopBurnLevel: 100 },
    },
    cook_mawshark: {
        id: 'cook_mawshark',
        skill: 'cooking',
        levelReq: 90,
        name: 'Feast of the Maw',
        inputs: [{ itemId: 'abyssal_mawshark', quantity: 1 }],
        outputItemId: 'feast_of_the_maw',
        outputQuantity: 1,
        xp: 92,
        intervalSeconds: 2.4,
        burnRateAtLevel: { startLevel: 90, startBurnRate: 0.3, stopBurnLevel: 115 },
    },
    // === AGRONOMY & BOTANY (Farming) ===
    farm_earthtuber: {
        id: 'farm_earthtuber',
        skill: 'farming',
        levelReq: 1,
        name: 'Earthtuber',
        inputs: [{ itemId: 'earthtuber_seed', quantity: 1 }],
        outputItemId: 'earthtuber',
        outputQuantity: 4,
        xp: 45,
        intervalSeconds: 4.0,
        rareFinds: [
            { itemId: 'earthtuber_seed', chance: 0.5 },
            { itemId: 'pet_sprout', chance: 1 / 15000 },
        ],
    },
    farm_silverleaf: {
        id: 'farm_silverleaf',
        skill: 'farming',
        levelReq: 10,
        name: 'Silverleaf',
        inputs: [{ itemId: 'silverleaf_seed', quantity: 1 }],
        outputItemId: 'silverleaf',
        outputQuantity: 4,
        xp: 95,
        intervalSeconds: 4.5,
        rareFinds: [
            { itemId: 'silverleaf_seed', chance: 0.45 },
            { itemId: 'pet_sprout', chance: 1 / 12000 },
        ],
    },
    farm_glowshroom: {
        id: 'farm_glowshroom',
        skill: 'farming',
        levelReq: 20,
        name: 'Glowshroom',
        inputs: [{ itemId: 'glowshroom_spore', quantity: 1 }],
        outputItemId: 'glowshroom',
        outputQuantity: 5,
        xp: 180,
        intervalSeconds: 5.0,
        rareFinds: [
            { itemId: 'glowshroom_spore', chance: 0.4 },
            { itemId: 'pet_sprout', chance: 1 / 10000 },
        ],
    },
    farm_deep_radish: {
        id: 'farm_deep_radish',
        skill: 'farming',
        levelReq: 35,
        name: 'Deep Radish',
        inputs: [{ itemId: 'deep_radish_seed', quantity: 1 }],
        outputItemId: 'deep_radish',
        outputQuantity: 5,
        xp: 340,
        intervalSeconds: 5.5,
        rareFinds: [
            { itemId: 'deep_radish_seed', chance: 0.4 },
            { itemId: 'pet_sprout', chance: 1 / 8000 },
        ],
    },
    farm_nightshade: {
        id: 'farm_nightshade',
        skill: 'farming',
        levelReq: 45,
        name: 'Nightshade Bell',
        inputs: [{ itemId: 'nightshade_seed', quantity: 1 }],
        outputItemId: 'nightshade_bell',
        outputQuantity: 6,
        xp: 580,
        intervalSeconds: 7.0,
        rareFinds: [
            { itemId: 'nightshade_seed', chance: 0.35 },
            { itemId: 'pet_sprout', chance: 1 / 6500 },
        ],
    },
    farm_bramble_mandrake: {
        id: 'farm_bramble_mandrake',
        skill: 'farming',
        levelReq: 55,
        name: 'Bramble Mandrake',
        inputs: [{ itemId: 'bramble_mandrake_seed', quantity: 1 }],
        outputItemId: 'bramble_mandrake',
        outputQuantity: 6,
        xp: 880,
        intervalSeconds: 6.0,
        rareFinds: [
            { itemId: 'bramble_mandrake_seed', chance: 0.35 },
            { itemId: 'pet_sprout', chance: 1 / 5000 },
        ],
    },
    farm_wyrmfrond: {
        id: 'farm_wyrmfrond',
        skill: 'farming',
        levelReq: 70,
        name: 'Wyrmfrond',
        inputs: [{ itemId: 'wyrmfrond_seed', quantity: 1 }],
        outputItemId: 'wyrmfrond',
        outputQuantity: 7,
        xp: 1400,
        intervalSeconds: 8.5,
        rareFinds: [
            { itemId: 'wyrmfrond_seed', chance: 0.3 },
            { itemId: 'pet_sprout', chance: 1 / 4000 },
        ],
    },
    farm_nether_gourd: {
        id: 'farm_nether_gourd',
        skill: 'farming',
        levelReq: 80,
        name: 'Nether Gourd',
        inputs: [{ itemId: 'nether_gourd_seed', quantity: 1 }],
        outputItemId: 'nether_gourd',
        outputQuantity: 8,
        xp: 1900,
        intervalSeconds: 7.5,
        rareFinds: [
            { itemId: 'nether_gourd_seed', chance: 0.3 },
            { itemId: 'pet_sprout', chance: 1 / 3000 },
        ],
    },
    farm_sunfire_pod: {
        id: 'farm_sunfire_pod',
        skill: 'farming',
        levelReq: 90,
        name: 'Sunfire Pepper',
        inputs: [{ itemId: 'sunfire_pod', quantity: 1 }],
        outputItemId: 'sunfire_pepper',
        outputQuantity: 9,
        xp: 2600,
        intervalSeconds: 10.0,
        rareFinds: [
            { itemId: 'sunfire_pod', chance: 0.25 },
            { itemId: 'pet_sprout', chance: 1 / 2000 },
        ],
    },
    // ========================================================
    // 7. HERBALISM (Wild Foraging of Medicinal & Arcane Flora)
    // ========================================================
    gather_silverleaf: {
        id: 'gather_silverleaf',
        skill: 'herbalism',
        levelReq: 1,
        name: 'Silverleaf',
        inputs: [],
        outputItemId: 'silverleaf',
        outputQuantity: 1,
        xp: 3,
        intervalSeconds: 3.0,
        rareFinds: [{ itemId: 'silverleaf_seed', chance: 0.02 }],
    },
    gather_glowshroom: {
        id: 'gather_glowshroom',
        skill: 'herbalism',
        levelReq: 20,
        name: 'Glowshroom',
        inputs: [],
        outputItemId: 'glowshroom',
        outputQuantity: 1,
        xp: 6,
        intervalSeconds: 3.6,
        rareFinds: [{ itemId: 'glowshroom_spore', chance: 0.015 }],
    },
    gather_nightshade: {
        id: 'gather_nightshade',
        skill: 'herbalism',
        levelReq: 45,
        name: 'Nightshade Bell',
        inputs: [],
        outputItemId: 'nightshade_bell',
        outputQuantity: 1,
        xp: 16,
        intervalSeconds: 4.8,
        rareFinds: [{ itemId: 'nightshade_seed', chance: 0.01 }],
    },
    gather_bramble_mandrake: {
        id: 'gather_bramble_mandrake',
        skill: 'herbalism',
        levelReq: 55,
        name: 'Bramble Mandrake',
        inputs: [],
        outputItemId: 'bramble_mandrake',
        outputQuantity: 1,
        xp: 22,
        intervalSeconds: 5.4,
        rareFinds: [{ itemId: 'bramble_mandrake_seed', chance: 0.008 }],
    },
    gather_wyrmfrond: {
        id: 'gather_wyrmfrond',
        skill: 'herbalism',
        levelReq: 70,
        name: 'Wyrmfrond',
        inputs: [],
        outputItemId: 'wyrmfrond',
        outputQuantity: 1,
        xp: 40,
        intervalSeconds: 6.6,
        rareFinds: [{ itemId: 'wyrmfrond_seed', chance: 0.005 }],
    },
    gather_sunfire: {
        id: 'gather_sunfire',
        skill: 'herbalism',
        levelReq: 90,
        name: 'Sunfire Pepper',
        inputs: [],
        outputItemId: 'sunfire_pepper',
        outputQuantity: 1,
        xp: 70,
        intervalSeconds: 8.0,
        rareFinds: [{ itemId: 'sunfire_pod', chance: 0.003 }],
    },
    // ========================================================
    // 8. THIEVING (Town Market Stalls & Roguery)
    // ========================================================
    thieve_bakery: {
        id: 'thieve_bakery',
        skill: 'thieving',
        levelReq: 1,
        name: 'Bakery Stall',
        inputs: [],
        outputItemId: 'crusty_bread',
        outputQuantity: 1,
        xp: 4,
        intervalSeconds: 3.5,
        rareFinds: [{ itemId: 'gold', chance: 0.08 }],
    },
    thieve_cloth: {
        id: 'thieve_cloth',
        skill: 'thieving',
        levelReq: 5,
        name: 'Cloth Stall',
        inputs: [],
        outputItemId: 'homespun_bolt',
        outputQuantity: 1,
        xp: 6,
        intervalSeconds: 3.8,
        rareFinds: [{ itemId: 'gold', chance: 0.08 }],
    },
    thieve_produce: {
        id: 'thieve_produce',
        skill: 'thieving',
        levelReq: 15,
        name: 'Farmer Stall',
        inputs: [],
        outputItemId: 'earthtuber',
        outputQuantity: 1,
        xp: 7,
        intervalSeconds: 4.2,
        rareFinds: [{ itemId: 'earthtuber_seed', chance: 0.08 }],
    },
    thieve_silk: {
        id: 'thieve_silk',
        skill: 'thieving',
        levelReq: 35,
        name: 'Silk Merchant Stall',
        inputs: [],
        outputItemId: 'silk_bolt',
        outputQuantity: 1,
        xp: 18,
        intervalSeconds: 5.0,
        rareFinds: [{ itemId: 'gilded_bolt', chance: 0.06 }],
    },
    thieve_guard: {
        id: 'thieve_guard',
        skill: 'thieving',
        levelReq: 55,
        name: 'Hearth Sentry',
        inputs: [],
        outputItemId: 'gold',
        outputQuantity: 25,
        xp: 38,
        intervalSeconds: 5.8,
        rareFinds: [{ itemId: 'dry_sigil', chance: 0.05 }],
    },
    thieve_gem: {
        id: 'thieve_gem',
        skill: 'thieving',
        levelReq: 75,
        name: 'Jeweler Vault Stall',
        inputs: [],
        outputItemId: 'uncut_celestial_gem',
        outputQuantity: 1,
        xp: 75,
        intervalSeconds: 6.8,
        rareFinds: [{ itemId: 'cut_celestial_gem', chance: 0.04 }],
    },
    // ========================================================
    // 9. FLETCHING (Bows & Ranged Quivers)
    // ========================================================
    fletch_ashwood_shortbow: {
        id: 'fletch_ashwood_shortbow',
        skill: 'fletching',
        levelReq: 1,
        name: 'Ashwood Shortbow',
        inputs: [{ itemId: 'ashwood_timber', quantity: 2 }],
        outputItemId: 'ashwood_shortbow',
        outputQuantity: 1,
        xp: 15,
        intervalSeconds: 2.5,
    },
    fletch_leather_quiver: {
        id: 'fletch_leather_quiver',
        skill: 'fletching',
        levelReq: 5,
        name: 'Leather Quiver',
        inputs: [{ itemId: 'mire_rat_pelt', quantity: 2 }, { itemId: 'ashwood_timber', quantity: 1 }],
        outputItemId: 'leather_quiver',
        outputQuantity: 1,
        xp: 20,
        intervalSeconds: 2.8,
    },
    fletch_pelt_quiver: {
        id: 'fletch_pelt_quiver',
        skill: 'fletching',
        levelReq: 5,
        name: 'Leather Quiver',
        inputs: [{ itemId: 'mire_rat_pelt', quantity: 2 }, { itemId: 'ashwood_timber', quantity: 1 }],
        outputItemId: 'leather_quiver',
        outputQuantity: 1,
        xp: 20,
        intervalSeconds: 2.8,
    },
    fletch_oak_shortbow: {
        id: 'fletch_oak_shortbow',
        skill: 'fletching',
        levelReq: 15,
        name: 'Oak Shortbow',
        inputs: [{ itemId: 'whispering_oak', quantity: 2 }],
        outputItemId: 'oak_shortbow',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 3.2,
    },
    fletch_ghoulskin_quiver: {
        id: 'fletch_ghoulskin_quiver',
        skill: 'fletching',
        levelReq: 25,
        name: 'Ghoulskin Quiver',
        inputs: [{ itemId: 'ghoul_hide', quantity: 2 }, { itemId: 'whispering_oak', quantity: 1 }],
        outputItemId: 'ghoulskin_quiver',
        outputQuantity: 1,
        xp: 55,
        intervalSeconds: 3.5,
    },
    fletch_willow_shortbow: {
        id: 'fletch_willow_shortbow',
        skill: 'fletching',
        levelReq: 30,
        name: 'Willow Shortbow',
        inputs: [{ itemId: 'weeping_willow', quantity: 2 }],
        outputItemId: 'willow_shortbow',
        outputQuantity: 1,
        xp: 70,
        intervalSeconds: 3.8,
    },
    fletch_chitin_quiver: {
        id: 'fletch_chitin_quiver',
        skill: 'fletching',
        levelReq: 40,
        name: 'Chitin Quiver',
        inputs: [{ itemId: 'crypt_carapace', quantity: 2 }, { itemId: 'weeping_willow', quantity: 1 }],
        outputItemId: 'chitin_quiver',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 4.0,
    },
    fletch_bloodwood_shortbow: {
        id: 'fletch_bloodwood_shortbow',
        skill: 'fletching',
        levelReq: 45,
        name: 'Bloodwood Shortbow',
        inputs: [{ itemId: 'bloodwood_timber', quantity: 2 }],
        outputItemId: 'bloodwood_shortbow',
        outputQuantity: 1,
        xp: 130,
        intervalSeconds: 4.5,
    },
    fletch_ghostwood_shortbow: {
        id: 'fletch_ghostwood_shortbow',
        skill: 'fletching',
        levelReq: 60,
        name: 'Ghostwood Shortbow',
        inputs: [{ itemId: 'ghostwood_timber', quantity: 2 }],
        outputItemId: 'ghostwood_shortbow',
        outputQuantity: 1,
        xp: 240,
        intervalSeconds: 5.0,
    },
    fletch_starlight_shortbow: {
        id: 'fletch_starlight_shortbow',
        skill: 'fletching',
        levelReq: 75,
        name: 'Starlight Shortbow',
        inputs: [{ itemId: 'starlight_timber', quantity: 2 }],
        outputItemId: 'starlight_shortbow',
        outputQuantity: 1,
        animaCost: 20,
        xp: 420,
        intervalSeconds: 6.0,
    },
    fletch_fur_quiver: {
        id: 'fletch_fur_quiver',
        skill: 'fletching',
        levelReq: 60,
        name: 'Fur Quiver',
        inputs: [{ itemId: 'frost_worg_fur', quantity: 2 }, { itemId: 'ghostwood_timber', quantity: 1 }],
        outputItemId: 'fur_quiver',
        outputQuantity: 1,
        xp: 260,
        intervalSeconds: 5.2,
    },
    fletch_scale_quiver: {
        id: 'fletch_scale_quiver',
        skill: 'fletching',
        levelReq: 85,
        name: 'Scale Quiver',
        inputs: [{ itemId: 'drake_leather', quantity: 2 }, { itemId: 'starlight_timber', quantity: 1 }],
        outputItemId: 'scale_quiver',
        outputQuantity: 1,
        animaCost: 25,
        xp: 550,
        intervalSeconds: 6.5,
    },
    // --- Woodworking: Staves & Angling Rods ---
    fletch_ashwood_staff: {
        id: 'fletch_ashwood_staff',
        skill: 'fletching',
        levelReq: 1,
        name: 'Ashwood Staff',
        inputs: [{ itemId: 'ashwood_timber', quantity: 2 }],
        outputItemId: 'ashwood_staff',
        outputQuantity: 1,
        xp: 15,
        intervalSeconds: 2.6,
    },
    fletch_oak_staff: {
        id: 'fletch_oak_staff',
        skill: 'fletching',
        levelReq: 15,
        name: 'Oak Staff',
        inputs: [{ itemId: 'whispering_oak', quantity: 2 }],
        outputItemId: 'oak_staff',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 3.2,
    },
    fletch_willow_staff: {
        id: 'fletch_willow_staff',
        skill: 'fletching',
        levelReq: 30,
        name: 'Willow Staff',
        inputs: [{ itemId: 'weeping_willow', quantity: 2 }],
        outputItemId: 'willow_staff',
        outputQuantity: 1,
        xp: 70,
        intervalSeconds: 3.8,
    },
    fletch_bloodwood_staff: {
        id: 'fletch_bloodwood_staff',
        skill: 'fletching',
        levelReq: 45,
        name: 'Bloodwood Staff',
        inputs: [{ itemId: 'bloodwood_timber', quantity: 2 }],
        outputItemId: 'bloodwood_staff',
        outputQuantity: 1,
        xp: 130,
        intervalSeconds: 4.5,
    },
    fletch_ghostwood_staff: {
        id: 'fletch_ghostwood_staff',
        skill: 'fletching',
        levelReq: 60,
        name: 'Ghostwood Staff',
        inputs: [{ itemId: 'ghostwood_timber', quantity: 2 }],
        outputItemId: 'ghostwood_staff',
        outputQuantity: 1,
        xp: 260,
        intervalSeconds: 5.2,
    },
    fletch_starlight_staff: {
        id: 'fletch_starlight_staff',
        skill: 'fletching',
        levelReq: 75,
        name: 'Starlight Staff',
        inputs: [{ itemId: 'starlight_timber', quantity: 2 }],
        outputItemId: 'starlight_staff',
        outputQuantity: 1,
        animaCost: 20,
        xp: 450,
        intervalSeconds: 6.2,
    },
    fletch_willow_rod: {
        id: 'fletch_willow_rod',
        skill: 'fletching',
        levelReq: 5,
        name: 'Willow Fishing Rod',
        inputs: [{ itemId: 'weeping_willow', quantity: 1 }],
        outputItemId: 'fishing_rod_willow',
        outputQuantity: 1,
        xp: 20,
        intervalSeconds: 3.0,
    },
    fletch_oak_rod: {
        id: 'fletch_oak_rod',
        skill: 'fletching',
        levelReq: 25,
        name: 'Oak Fishing Rod',
        inputs: [{ itemId: 'whispering_oak', quantity: 1 }],
        outputItemId: 'fishing_rod_oak',
        outputQuantity: 1,
        xp: 60,
        intervalSeconds: 3.8,
    },
    fletch_yew_rod: {
        id: 'fletch_yew_rod',
        skill: 'fletching',
        levelReq: 50,
        name: 'Yew Deep-Sea Rod',
        inputs: [{ itemId: 'ghostwood_timber', quantity: 1 }],
        outputItemId: 'fishing_rod_yew',
        outputQuantity: 1,
        xp: 160,
        intervalSeconds: 4.6,
    },
    // ========================================================
    // 10. ALCHEMY (Draughts, Elixirs & Phials)
    // ========================================================
    brew_artisans_draught: {
        id: 'brew_artisans_draught',
        skill: 'alchemy',
        levelReq: 1,
        name: "Artisan's Draught",
        inputs: [{ itemId: 'silverleaf', quantity: 1 }, { itemId: 'pyrite_ore', quantity: 1 }],
        outputItemId: 'artisans_draught',
        outputQuantity: 1,
        xp: 15,
        intervalSeconds: 2.8,
    },
    brew_zephyr_phial: {
        id: 'brew_zephyr_phial',
        skill: 'alchemy',
        levelReq: 15,
        name: 'Zephyr Phial',
        inputs: [{ itemId: 'silverleaf', quantity: 2 }, { itemId: 'galena_ore', quantity: 1 }],
        outputItemId: 'zephyr_phial',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 3.2,
    },
    brew_predators_elixir: {
        id: 'brew_predators_elixir',
        skill: 'alchemy',
        levelReq: 30,
        name: "Predator's Elixir",
        inputs: [{ itemId: 'glowshroom', quantity: 2 }, { itemId: 'cold_iron_ore', quantity: 1 }],
        outputItemId: 'predators_elixir',
        outputQuantity: 1,
        xp: 70,
        intervalSeconds: 3.8,
    },
    brew_restorative_draught: {
        id: 'brew_restorative_draught',
        skill: 'alchemy',
        levelReq: 45,
        name: 'Restorative Draught',
        inputs: [{ itemId: 'nightshade_bell', quantity: 2 }, { itemId: 'nethercoal', quantity: 1 }],
        outputItemId: 'restorative_draught',
        outputQuantity: 1,
        xp: 130,
        intervalSeconds: 4.5,
    },
    brew_warmasters_draught: {
        id: 'brew_warmasters_draught',
        skill: 'alchemy',
        levelReq: 60,
        name: "Warmaster's Draught",
        inputs: [{ itemId: 'nightshade_bell', quantity: 2 }, { itemId: 'solar_aurum_ore', quantity: 1 }],
        outputItemId: 'warmasters_draught',
        outputQuantity: 1,
        xp: 220,
        intervalSeconds: 5.2,
    },
    brew_celerity_flask: {
        id: 'brew_celerity_flask',
        skill: 'alchemy',
        levelReq: 75,
        name: 'Celerity Flask',
        inputs: [{ itemId: 'wyrmfrond', quantity: 2 }, { itemId: 'quicksilver_ore', quantity: 2 }],
        outputItemId: 'celerity_flask',
        outputQuantity: 1,
        xp: 360,
        intervalSeconds: 6.0,
    },
    brew_eldervault_elixir: {
        id: 'brew_eldervault_elixir',
        skill: 'alchemy',
        levelReq: 85,
        name: 'Elixir of the Eldervault',
        inputs: [{ itemId: 'wyrmfrond', quantity: 2 }, { itemId: 'azurite_ore', quantity: 1 }],
        outputItemId: 'elixir_of_the_eldervault',
        outputQuantity: 1,
        animaCost: 20,
        xp: 520,
        intervalSeconds: 7.0,
    },
    brew_abyssal_gold: {
        id: 'brew_abyssal_gold',
        skill: 'alchemy',
        levelReq: 95,
        name: 'Abyssal Gold Phial',
        inputs: [{ itemId: 'sunfire_pepper', quantity: 2 }, { itemId: 'starfall_ore', quantity: 1 }],
        outputItemId: 'abyssal_gold_phial',
        outputQuantity: 1,
        animaCost: 35,
        xp: 750,
        intervalSeconds: 8.5,
    },
    // ========================================================
    // 11. CRAFTING (Tailoring, Leatherworking & Gemcutting)
    // ========================================================
    // --- Ranged Armor Sets (Leather & Hides) ---
    craft_ranger_hood: {
        id: 'craft_ranger_hood',
        skill: 'crafting',
        levelReq: 1,
        name: 'Ranger Cowl',
        inputs: [{ itemId: 'mire_rat_pelt', quantity: 2 }],
        outputItemId: 'ranger_hood',
        outputQuantity: 1,
        xp: 12,
        intervalSeconds: 2.4,
    },
    craft_leather_tunic: {
        id: 'craft_leather_tunic',
        skill: 'crafting',
        levelReq: 3,
        name: 'Leather Tunic',
        inputs: [{ itemId: 'mire_rat_pelt', quantity: 3 }],
        outputItemId: 'leather_tunic',
        outputQuantity: 1,
        xp: 16,
        intervalSeconds: 2.6,
    },
    craft_leather_chaps: {
        id: 'craft_leather_chaps',
        skill: 'crafting',
        levelReq: 5,
        name: 'Leather Chaps',
        inputs: [{ itemId: 'mire_rat_pelt', quantity: 2 }],
        outputItemId: 'leather_chaps',
        outputQuantity: 1,
        xp: 20,
        intervalSeconds: 2.8,
    },
    craft_ghoulskin_hood: {
        id: 'craft_ghoulskin_hood',
        skill: 'crafting',
        levelReq: 16,
        name: 'Ghoulskin Hood',
        inputs: [{ itemId: 'ghoul_hide', quantity: 2 }],
        outputItemId: 'ghoulskin_hood',
        outputQuantity: 1,
        xp: 32,
        intervalSeconds: 2.8,
    },
    craft_ghoulskin_tunic: {
        id: 'craft_ghoulskin_tunic',
        skill: 'crafting',
        levelReq: 20,
        name: 'Ghoulskin Tunic',
        inputs: [{ itemId: 'ghoul_hide', quantity: 3 }],
        outputItemId: 'ghoulskin_tunic',
        outputQuantity: 1,
        xp: 42,
        intervalSeconds: 3.0,
    },
    craft_ghoulskin_chaps: {
        id: 'craft_ghoulskin_chaps',
        skill: 'crafting',
        levelReq: 24,
        name: 'Ghoulskin Chaps',
        inputs: [{ itemId: 'ghoul_hide', quantity: 2 }],
        outputItemId: 'ghoulskin_chaps',
        outputQuantity: 1,
        xp: 50,
        intervalSeconds: 3.0,
    },
    craft_chitin_cowl: {
        id: 'craft_chitin_cowl',
        skill: 'crafting',
        levelReq: 34,
        name: 'Chitin Cowl',
        inputs: [{ itemId: 'crypt_carapace', quantity: 2 }],
        outputItemId: 'chitin_cowl',
        outputQuantity: 1,
        xp: 68,
        intervalSeconds: 3.2,
    },
    craft_chitin_vest: {
        id: 'craft_chitin_vest',
        skill: 'crafting',
        levelReq: 38,
        name: 'Chitin Vest',
        inputs: [{ itemId: 'crypt_carapace', quantity: 3 }, { itemId: 'steel_ingot', quantity: 1 }],
        outputItemId: 'chitin_vest',
        outputQuantity: 1,
        xp: 85,
        intervalSeconds: 3.4,
    },
    craft_chitin_chaps: {
        id: 'craft_chitin_chaps',
        skill: 'crafting',
        levelReq: 42,
        name: 'Chitin Chaps',
        inputs: [{ itemId: 'crypt_carapace', quantity: 2 }],
        outputItemId: 'chitin_chaps',
        outputQuantity: 1,
        xp: 95,
        intervalSeconds: 3.4,
    },
    craft_ranger_hat: {
        id: 'craft_ranger_hat',
        skill: 'crafting',
        levelReq: 46,
        name: 'Ranger Hat',
        inputs: [{ itemId: 'spectre_ash', quantity: 2 }, { itemId: 'solar_aurum_ingot', quantity: 1 }],
        outputItemId: 'ranger_hat',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 3.4,
    },
    craft_ranger_tunic: {
        id: 'craft_ranger_tunic',
        skill: 'crafting',
        levelReq: 49,
        name: 'Ranger Tunic',
        inputs: [{ itemId: 'spectre_ash', quantity: 3 }, { itemId: 'solar_aurum_ingot', quantity: 1 }],
        outputItemId: 'ranger_tunic',
        outputQuantity: 1,
        xp: 125,
        intervalSeconds: 3.6,
    },
    craft_ranger_chaps: {
        id: 'craft_ranger_chaps',
        skill: 'crafting',
        levelReq: 52,
        name: 'Ranger Chaps',
        inputs: [{ itemId: 'spectre_ash', quantity: 2 }, { itemId: 'bloodwood_timber', quantity: 1 }],
        outputItemId: 'ranger_chaps',
        outputQuantity: 1,
        xp: 115,
        intervalSeconds: 3.4,
    },
    craft_fur_cowl: {
        id: 'craft_fur_cowl',
        skill: 'crafting',
        levelReq: 62,
        name: 'Frost-Fur Cowl',
        inputs: [{ itemId: 'frost_worg_fur', quantity: 2 }],
        outputItemId: 'fur_cowl',
        outputQuantity: 1,
        xp: 140,
        intervalSeconds: 3.6,
    },
    craft_fur_jerkin: {
        id: 'craft_fur_jerkin',
        skill: 'crafting',
        levelReq: 66,
        name: 'Frost-Fur Jerkin',
        inputs: [{ itemId: 'frost_worg_fur', quantity: 3 }, { itemId: 'azurite_ingot', quantity: 1 }],
        outputItemId: 'fur_jerkin',
        outputQuantity: 1,
        xp: 175,
        intervalSeconds: 4.0,
    },
    craft_fur_leggings: {
        id: 'craft_fur_leggings',
        skill: 'crafting',
        levelReq: 70,
        name: 'Frost-Fur Leggings',
        inputs: [{ itemId: 'frost_worg_fur', quantity: 2 }],
        outputItemId: 'fur_leggings',
        outputQuantity: 1,
        xp: 195,
        intervalSeconds: 4.0,
    },
    craft_drake_cowl: {
        id: 'craft_drake_cowl',
        skill: 'crafting',
        levelReq: 86,
        name: 'Drake-Scale Cowl',
        inputs: [{ itemId: 'drake_leather', quantity: 2 }, { itemId: 'draconic_scale', quantity: 1 }],
        outputItemId: 'drake_cowl',
        outputQuantity: 1,
        xp: 260,
        intervalSeconds: 4.5,
    },
    craft_drake_hauberk: {
        id: 'craft_drake_hauberk',
        skill: 'crafting',
        levelReq: 90,
        name: 'Drake-Scale Hauberk',
        inputs: [{ itemId: 'drake_leather', quantity: 3 }, { itemId: 'draconic_scale', quantity: 1 }],
        outputItemId: 'drake_hauberk',
        outputQuantity: 1,
        xp: 320,
        intervalSeconds: 4.8,
    },
    craft_drake_chaps: {
        id: 'craft_drake_chaps',
        skill: 'crafting',
        levelReq: 94,
        name: 'Drake-Scale Chaps',
        inputs: [{ itemId: 'drake_leather', quantity: 2 }, { itemId: 'draconic_scale', quantity: 1 }],
        outputItemId: 'drake_chaps',
        outputQuantity: 1,
        xp: 360,
        intervalSeconds: 4.8,
    },
    // --- Magic Robe Sets (Cloth & Sorcery) ---
    craft_wizard_hat: {
        id: 'craft_wizard_hat',
        skill: 'crafting',
        levelReq: 1,
        name: 'Apprentice Wizard Hat',
        inputs: [{ itemId: 'homespun_bolt', quantity: 2 }],
        outputItemId: 'wizard_hat',
        outputQuantity: 1,
        xp: 12,
        intervalSeconds: 2.4,
    },
    craft_apprentice_robe_top: {
        id: 'craft_apprentice_robe_top',
        skill: 'crafting',
        levelReq: 4,
        name: 'Apprentice Robe Top',
        inputs: [{ itemId: 'homespun_bolt', quantity: 3 }],
        outputItemId: 'apprentice_robe_top',
        outputQuantity: 1,
        xp: 18,
        intervalSeconds: 2.6,
    },
    craft_apprentice_robe_bottom: {
        id: 'craft_apprentice_robe_bottom',
        skill: 'crafting',
        levelReq: 7,
        name: 'Apprentice Robe Bottom',
        inputs: [{ itemId: 'homespun_bolt', quantity: 2 }],
        outputItemId: 'apprentice_robe_bottom',
        outputQuantity: 1,
        xp: 22,
        intervalSeconds: 2.8,
    },
    craft_silk_mage_hat: {
        id: 'craft_silk_mage_hat',
        skill: 'crafting',
        levelReq: 18,
        name: 'Silk Mage Hat',
        inputs: [{ itemId: 'silk_bolt', quantity: 2 }],
        outputItemId: 'silk_mage_hat',
        outputQuantity: 1,
        xp: 36,
        intervalSeconds: 2.8,
    },
    craft_silk_robe_top: {
        id: 'craft_silk_robe_top',
        skill: 'crafting',
        levelReq: 22,
        name: 'Silk Robe Top',
        inputs: [{ itemId: 'silk_bolt', quantity: 3 }],
        outputItemId: 'silk_robe_top',
        outputQuantity: 1,
        xp: 46,
        intervalSeconds: 3.0,
    },
    craft_silk_robe_bottom: {
        id: 'craft_silk_robe_bottom',
        skill: 'crafting',
        levelReq: 26,
        name: 'Silk Robe Bottom',
        inputs: [{ itemId: 'silk_bolt', quantity: 2 }],
        outputItemId: 'silk_robe_bottom',
        outputQuantity: 1,
        xp: 54,
        intervalSeconds: 3.0,
    },
    craft_gilded_mystic_hat: {
        id: 'craft_gilded_mystic_hat',
        skill: 'crafting',
        levelReq: 36,
        name: 'Gilded Mystic Hat',
        inputs: [{ itemId: 'gilded_bolt', quantity: 2 }],
        outputItemId: 'gilded_mystic_hat',
        outputQuantity: 1,
        xp: 75,
        intervalSeconds: 3.2,
    },
    craft_gilded_robe_top: {
        id: 'craft_gilded_robe_top',
        skill: 'crafting',
        levelReq: 40,
        name: 'Gilded Mystic Robe',
        inputs: [{ itemId: 'gilded_bolt', quantity: 3 }],
        outputItemId: 'gilded_robe_top',
        outputQuantity: 1,
        xp: 90,
        intervalSeconds: 3.5,
    },
    craft_gilded_robe_bottom: {
        id: 'craft_gilded_robe_bottom',
        skill: 'crafting',
        levelReq: 44,
        name: 'Gilded Mystic Bottom',
        inputs: [{ itemId: 'gilded_bolt', quantity: 2 }],
        outputItemId: 'gilded_robe_bottom',
        outputQuantity: 1,
        xp: 105,
        intervalSeconds: 3.5,
    },
    craft_voidweave_bolt: {
        id: 'craft_voidweave_bolt',
        skill: 'crafting',
        levelReq: 60,
        name: 'Voidweave Bolt',
        inputs: [
            { itemId: 'silk_bolt', quantity: 2 },
            { itemId: 'spectre_ash', quantity: 1 },
        ],
        outputItemId: 'voidweave_bolt',
        outputQuantity: 1,
        animaCost: 15,
        xp: 135,
        intervalSeconds: 3.5,
    },
    craft_voidweave_cowl: {
        id: 'craft_voidweave_cowl',
        skill: 'crafting',
        levelReq: 64,
        name: 'Voidweave Cowl',
        inputs: [{ itemId: 'voidweave_bolt', quantity: 2 }, { itemId: 'spectre_ash', quantity: 1 }],
        outputItemId: 'voidweave_cowl',
        outputQuantity: 1,
        xp: 155,
        intervalSeconds: 3.8,
    },
    craft_voidweave_robe_top: {
        id: 'craft_voidweave_robe_top',
        skill: 'crafting',
        levelReq: 68,
        name: 'Voidweave Robe',
        inputs: [{ itemId: 'voidweave_bolt', quantity: 3 }, { itemId: 'spectre_ash', quantity: 1 }],
        outputItemId: 'voidweave_robe_top',
        outputQuantity: 1,
        xp: 185,
        intervalSeconds: 4.2,
    },
    craft_voidweave_skirt: {
        id: 'craft_voidweave_skirt',
        skill: 'crafting',
        levelReq: 72,
        name: 'Voidweave Skirt',
        inputs: [{ itemId: 'voidweave_bolt', quantity: 2 }, { itemId: 'spectre_ash', quantity: 1 }],
        outputItemId: 'voidweave_skirt',
        outputQuantity: 1,
        xp: 210,
        intervalSeconds: 4.2,
    },
    craft_celestial_crown: {
        id: 'craft_celestial_crown',
        skill: 'crafting',
        levelReq: 88,
        name: 'Celestial Archmage Crown',
        inputs: [{ itemId: 'voidweave_bolt', quantity: 2 }, { itemId: 'cut_celestial_gem', quantity: 1 }],
        outputItemId: 'celestial_crown',
        outputQuantity: 1,
        xp: 280,
        intervalSeconds: 4.5,
    },
    craft_celestial_robe_top: {
        id: 'craft_celestial_robe_top',
        skill: 'crafting',
        levelReq: 92,
        name: 'Celestial Archmage Robe',
        inputs: [{ itemId: 'voidweave_bolt', quantity: 3 }, { itemId: 'void_ichor', quantity: 1 }],
        outputItemId: 'celestial_robe_top',
        outputQuantity: 1,
        xp: 340,
        intervalSeconds: 4.8,
    },
    craft_celestial_skirt: {
        id: 'craft_celestial_skirt',
        skill: 'crafting',
        levelReq: 96,
        name: 'Celestial Archmage Skirt',
        inputs: [{ itemId: 'voidweave_bolt', quantity: 2 }, { itemId: 'void_ichor', quantity: 1 }],
        outputItemId: 'celestial_skirt',
        outputQuantity: 1,
        xp: 380,
        intervalSeconds: 4.8,
    },
    // --- Grimoires & Arcane Totes ---
    craft_linen_grimoire: {
        id: 'craft_linen_grimoire',
        skill: 'crafting',
        levelReq: 10,
        name: 'Linen Grimoire',
        inputs: [{ itemId: 'homespun_bolt', quantity: 2 }, { itemId: 'ashwood_timber', quantity: 1 }],
        outputItemId: 'linen_grimoire',
        outputQuantity: 1,
        xp: 30,
        intervalSeconds: 3.0,
    },
    craft_cut_celestial_gem: {
        id: 'craft_cut_celestial_gem',
        skill: 'crafting',
        levelReq: 25,
        name: 'Cut Celestial Gem',
        inputs: [{ itemId: 'uncut_celestial_gem', quantity: 1 }],
        outputItemId: 'cut_celestial_gem',
        outputQuantity: 1,
        xp: 60,
        intervalSeconds: 3.2,
    },
    craft_silk_grimoire: {
        id: 'craft_silk_grimoire',
        skill: 'crafting',
        levelReq: 35,
        name: 'Silk Grimoire',
        inputs: [{ itemId: 'silk_bolt', quantity: 2 }, { itemId: 'whispering_oak', quantity: 1 }],
        outputItemId: 'silk_grimoire',
        outputQuantity: 1,
        xp: 95,
        intervalSeconds: 3.8,
    },
    craft_gilded_grimoire: {
        id: 'craft_gilded_grimoire',
        skill: 'crafting',
        levelReq: 55,
        name: 'Gilded Grimoire',
        inputs: [{ itemId: 'gilded_bolt', quantity: 2 }, { itemId: 'cut_celestial_gem', quantity: 1 }],
        outputItemId: 'gilded_grimoire',
        outputQuantity: 1,
        xp: 220,
        intervalSeconds: 4.8,
    },
    craft_voidweave_grimoire: {
        id: 'craft_voidweave_grimoire',
        skill: 'crafting',
        levelReq: 80,
        name: 'Voidweave Grimoire',
        inputs: [{ itemId: 'voidweave_bolt', quantity: 2 }],
        outputItemId: 'voidweave_grimoire',
        outputQuantity: 1,
        animaCost: 25,
        xp: 480,
        intervalSeconds: 6.2,
    },
    // --- Jewelry: Rings & Bands ---
    craft_dawnburn_ring: {
        id: 'craft_dawnburn_ring',
        skill: 'crafting',
        levelReq: 1,
        name: 'Dawnburn Band',
        inputs: [{ itemId: 'dawnburn_ingot', quantity: 1 }],
        outputItemId: 'dawnburn_ring',
        outputQuantity: 1,
        xp: 8,
        intervalSeconds: 2.0,
    },
    craft_gnawed_bone_ring: {
        id: 'craft_gnawed_bone_ring',
        skill: 'crafting',
        levelReq: 8,
        name: 'Gnawed Bone Ring',
        inputs: [{ itemId: 'dawnburn_ingot', quantity: 1 }, { itemId: 'gnawed_talisman', quantity: 1 }],
        outputItemId: 'gnawed_bone_ring',
        outputQuantity: 1,
        xp: 20,
        intervalSeconds: 2.4,
    },
    craft_cold_iron_ring: {
        id: 'craft_cold_iron_ring',
        skill: 'crafting',
        levelReq: 15,
        name: 'Cold Iron Ring',
        inputs: [{ itemId: 'cold_iron_ingot', quantity: 1 }],
        outputItemId: 'cold_iron_ring',
        outputQuantity: 1,
        xp: 18,
        intervalSeconds: 2.4,
    },
    craft_prospector_ring: {
        id: 'craft_prospector_ring',
        skill: 'crafting',
        levelReq: 20,
        name: 'Ring of the Prospector',
        inputs: [{ itemId: 'cold_iron_ingot', quantity: 1 }, { itemId: 'pyrite_ore', quantity: 1 }, { itemId: 'nethercoal', quantity: 1 }],
        outputItemId: 'prospector_ring',
        outputQuantity: 1,
        xp: 30,
        intervalSeconds: 3.0,
    },
    craft_celestial_ring: {
        id: 'craft_celestial_ring',
        skill: 'crafting',
        levelReq: 28,
        name: 'Celestial Star Ring',
        inputs: [{ itemId: 'cold_iron_ingot', quantity: 1 }, { itemId: 'cut_celestial_gem', quantity: 1 }],
        outputItemId: 'celestial_ring',
        outputQuantity: 1,
        xp: 45,
        intervalSeconds: 3.0,
    },
    craft_steel_ring: {
        id: 'craft_steel_ring',
        skill: 'crafting',
        levelReq: 35,
        name: 'Tempered Steel Band',
        inputs: [{ itemId: 'steel_ingot', quantity: 1 }],
        outputItemId: 'steel_ring',
        outputQuantity: 1,
        xp: 42,
        intervalSeconds: 2.8,
    },
    craft_quicksilver_ring: {
        id: 'craft_quicksilver_ring',
        skill: 'crafting',
        levelReq: 35,
        name: 'Quicksilver Band',
        inputs: [{ itemId: 'quicksilver_ore', quantity: 1 }, { itemId: 'cold_iron_ingot', quantity: 1 }],
        outputItemId: 'quicksilver_ring',
        outputQuantity: 1,
        xp: 48,
        intervalSeconds: 2.8,
    },
    craft_dry_sigil_ring: {
        id: 'craft_dry_sigil_ring',
        skill: 'crafting',
        levelReq: 42,
        name: 'Dune Sigil Band',
        inputs: [{ itemId: 'steel_ingot', quantity: 1 }, { itemId: 'dry_sigil', quantity: 1 }],
        outputItemId: 'dry_sigil_ring',
        outputQuantity: 1,
        xp: 60,
        intervalSeconds: 3.0,
    },
    craft_solar_ring: {
        id: 'craft_solar_ring',
        skill: 'crafting',
        levelReq: 52,
        name: 'Solar Aurum Band',
        inputs: [{ itemId: 'solar_aurum_ingot', quantity: 1 }],
        outputItemId: 'solar_ring',
        outputQuantity: 1,
        xp: 68,
        intervalSeconds: 3.0,
    },
    craft_azurite_ring: {
        id: 'craft_azurite_ring',
        skill: 'crafting',
        levelReq: 65,
        name: 'Azurite Signet Ring',
        inputs: [{ itemId: 'azurite_ingot', quantity: 1 }],
        outputItemId: 'azurite_ring',
        outputQuantity: 1,
        xp: 95,
        intervalSeconds: 3.0,
    },
    craft_venomfang_ring: {
        id: 'craft_venomfang_ring',
        skill: 'crafting',
        levelReq: 75,
        name: 'Venomfang Band',
        inputs: [{ itemId: 'azurite_ingot', quantity: 1 }, { itemId: 'venomfang', quantity: 1 }],
        outputItemId: 'venomfang_ring',
        outputQuantity: 1,
        xp: 130,
        intervalSeconds: 3.4,
    },
    craft_astralite_ring: {
        id: 'craft_astralite_ring',
        skill: 'crafting',
        levelReq: 86,
        name: 'Astralite Star Ring',
        inputs: [{ itemId: 'astralite_ingot', quantity: 1 }, { itemId: 'cut_celestial_gem', quantity: 1 }],
        outputItemId: 'astralite_ring',
        outputQuantity: 1,
        xp: 175,
        intervalSeconds: 3.6,
    },
    craft_frost_tusk_ring: {
        id: 'craft_frost_tusk_ring',
        skill: 'crafting',
        levelReq: 88,
        name: "Frost Jarl's Tusk Ring",
        inputs: [{ itemId: 'astralite_ingot', quantity: 1 }, { itemId: 'frost_tusk', quantity: 1 }],
        outputItemId: 'frost_tusk_ring',
        outputQuantity: 1,
        xp: 190,
        intervalSeconds: 3.8,
    },
    craft_draconic_ring: {
        id: 'craft_draconic_ring',
        skill: 'crafting',
        levelReq: 94,
        name: 'Draconic Scale Band',
        inputs: [{ itemId: 'astralite_ingot', quantity: 1 }, { itemId: 'draconic_scale', quantity: 1 }],
        outputItemId: 'draconic_ring',
        outputQuantity: 1,
        xp: 240,
        intervalSeconds: 4.0,
    },
    craft_titan_ring: {
        id: 'craft_titan_ring',
        skill: 'crafting',
        levelReq: 98,
        name: 'Ring of the Earth Titan',
        inputs: [{ itemId: 'astralite_ingot', quantity: 1 }, { itemId: 'titan_core', quantity: 1 }, { itemId: 'titan_shard', quantity: 1 }],
        outputItemId: 'titan_ring',
        outputQuantity: 1,
        xp: 300,
        intervalSeconds: 4.5,
    },
    // --- Jewelry: Amulets & Talismans ---
    craft_dawnburn_amulet: {
        id: 'craft_dawnburn_amulet',
        skill: 'crafting',
        levelReq: 3,
        name: 'Dawnburn Talisman',
        inputs: [{ itemId: 'dawnburn_ingot', quantity: 1 }, { itemId: 'mire_rat_pelt', quantity: 1 }],
        outputItemId: 'dawnburn_amulet',
        outputQuantity: 1,
        xp: 12,
        intervalSeconds: 2.4,
    },
    craft_cold_iron_amulet: {
        id: 'craft_cold_iron_amulet',
        skill: 'crafting',
        levelReq: 18,
        name: 'Cold Iron Pendant',
        inputs: [{ itemId: 'cold_iron_ingot', quantity: 1 }, { itemId: 'ghoul_hide', quantity: 1 }],
        outputItemId: 'cold_iron_amulet',
        outputQuantity: 1,
        xp: 24,
        intervalSeconds: 2.8,
    },
    craft_bog_pearl_amulet: {
        id: 'craft_bog_pearl_amulet',
        skill: 'crafting',
        levelReq: 24,
        name: 'Bog Pearl Necklace',
        inputs: [{ itemId: 'cold_iron_ingot', quantity: 1 }, { itemId: 'bog_pearl', quantity: 1 }],
        outputItemId: 'bog_pearl_amulet',
        outputQuantity: 1,
        xp: 38,
        intervalSeconds: 3.0,
    },
    craft_steel_amulet: {
        id: 'craft_steel_amulet',
        skill: 'crafting',
        levelReq: 38,
        name: 'Steel Gorget Amulet',
        inputs: [{ itemId: 'steel_ingot', quantity: 1 }, { itemId: 'crypt_carapace', quantity: 1 }],
        outputItemId: 'steel_amulet',
        outputQuantity: 1,
        xp: 50,
        intervalSeconds: 3.0,
    },
    craft_quicksilver_amulet: {
        id: 'craft_quicksilver_amulet',
        skill: 'crafting',
        levelReq: 42,
        name: 'Quicksilver Pendant',
        inputs: [{ itemId: 'quicksilver_ore', quantity: 2 }, { itemId: 'steel_ingot', quantity: 1 }],
        outputItemId: 'quicksilver_amulet',
        outputQuantity: 1,
        xp: 62,
        intervalSeconds: 3.0,
    },
    craft_ossuary_amulet: {
        id: 'craft_ossuary_amulet',
        skill: 'crafting',
        levelReq: 48,
        name: 'Ossuary Bone Choker',
        inputs: [{ itemId: 'steel_ingot', quantity: 1 }, { itemId: 'ossuary_bone', quantity: 1 }, { itemId: 'cairn_sigil', quantity: 1 }],
        outputItemId: 'ossuary_amulet',
        outputQuantity: 1,
        xp: 75,
        intervalSeconds: 3.2,
    },
    craft_solar_amulet: {
        id: 'craft_solar_amulet',
        skill: 'crafting',
        levelReq: 56,
        name: 'Amulet of the Sun',
        inputs: [{ itemId: 'solar_aurum_ingot', quantity: 1 }, { itemId: 'solar_remnant', quantity: 1 }],
        outputItemId: 'solar_amulet',
        outputQuantity: 1,
        xp: 88,
        intervalSeconds: 3.2,
    },
    craft_rimefang_amulet: {
        id: 'craft_rimefang_amulet',
        skill: 'crafting',
        levelReq: 70,
        name: 'Rimefang Choker',
        inputs: [{ itemId: 'azurite_ingot', quantity: 1 }, { itemId: 'rimefang', quantity: 1 }],
        outputItemId: 'rimefang_amulet',
        outputQuantity: 1,
        xp: 115,
        intervalSeconds: 3.4,
    },
    craft_cinder_amulet: {
        id: 'craft_cinder_amulet',
        skill: 'crafting',
        levelReq: 80,
        name: 'Cinder Core Talisman',
        inputs: [{ itemId: 'azurite_ingot', quantity: 1 }, { itemId: 'cinder_core', quantity: 1 }],
        outputItemId: 'cinder_amulet',
        outputQuantity: 1,
        xp: 155,
        intervalSeconds: 3.6,
    },
    craft_anima_amulet: {
        id: 'craft_anima_amulet',
        skill: 'crafting',
        levelReq: 90,
        name: 'Anima Soul Pendant',
        inputs: [{ itemId: 'astralite_ingot', quantity: 1 }],
        outputItemId: 'anima_amulet',
        outputQuantity: 1,
        animaCost: 40,
        xp: 200,
        intervalSeconds: 3.8,
    },
    craft_glacial_amulet: {
        id: 'craft_glacial_amulet',
        skill: 'crafting',
        levelReq: 96,
        name: 'Glacial Crown Pendant',
        inputs: [{ itemId: 'astralite_ingot', quantity: 1 }, { itemId: 'glacial_crown', quantity: 1 }],
        outputItemId: 'glacial_amulet',
        outputQuantity: 1,
        xp: 260,
        intervalSeconds: 4.0,
    },
    craft_wyrm_amulet: {
        id: 'craft_wyrm_amulet',
        skill: 'crafting',
        levelReq: 99,
        name: 'Heart of the Pyro-Wyrm',
        inputs: [{ itemId: 'astralite_ingot', quantity: 1 }, { itemId: 'wyrm_ember', quantity: 1 }, { itemId: 'primordial_ember', quantity: 1 }],
        outputItemId: 'wyrm_amulet',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 5.0,
    },
    craft_leviathan_amulet: {
        id: 'craft_leviathan_amulet',
        skill: 'crafting',
        levelReq: 99,
        name: 'Eye of the Leviathan',
        inputs: [{ itemId: 'astralite_ingot', quantity: 1 }, { itemId: 'leviathan_scale', quantity: 1 }, { itemId: 'gazing_eye', quantity: 1 }],
        outputItemId: 'leviathan_amulet',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 5.0,
    },
    // ========================================================
    // 12. ATTUNEMENT (Staves, Anima Infusion & Sigil Wards)
    // ========================================================
    attune_ashwood_staff: {
        id: 'attune_ashwood_staff',
        skill: 'attunement',
        levelReq: 1,
        name: 'Ashwood Staff',
        inputs: [{ itemId: 'ashwood_timber', quantity: 2 }, { itemId: 'pyrite_ore', quantity: 1 }],
        outputItemId: 'ashwood_staff',
        outputQuantity: 1,
        xp: 15,
        intervalSeconds: 2.8,
    },
    attune_oak_staff: {
        id: 'attune_oak_staff',
        skill: 'attunement',
        levelReq: 15,
        name: 'Oak Staff',
        inputs: [{ itemId: 'whispering_oak', quantity: 2 }, { itemId: 'galena_ore', quantity: 1 }],
        outputItemId: 'oak_staff',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 3.2,
    },
    attune_willow_staff: {
        id: 'attune_willow_staff',
        skill: 'attunement',
        levelReq: 30,
        name: 'Willow Staff',
        inputs: [{ itemId: 'weeping_willow', quantity: 2 }, { itemId: 'cold_iron_ore', quantity: 1 }],
        outputItemId: 'willow_staff',
        outputQuantity: 1,
        xp: 70,
        intervalSeconds: 3.8,
    },
    attune_bloodwood_staff: {
        id: 'attune_bloodwood_staff',
        skill: 'attunement',
        levelReq: 45,
        name: 'Bloodwood Staff',
        inputs: [{ itemId: 'bloodwood_timber', quantity: 2 }, { itemId: 'solar_aurum_ore', quantity: 1 }],
        outputItemId: 'bloodwood_staff',
        outputQuantity: 1,
        xp: 130,
        intervalSeconds: 4.5,
    },
    attune_ghostwood_staff: {
        id: 'attune_ghostwood_staff',
        skill: 'attunement',
        levelReq: 60,
        name: 'Ghostwood Staff',
        inputs: [{ itemId: 'ghostwood_timber', quantity: 2 }, { itemId: 'cut_celestial_gem', quantity: 1 }],
        outputItemId: 'ghostwood_staff',
        outputQuantity: 1,
        xp: 220,
        intervalSeconds: 5.2,
    },
    attune_starlight_staff: {
        id: 'attune_starlight_staff',
        skill: 'attunement',
        levelReq: 75,
        name: 'Starlight Staff',
        inputs: [{ itemId: 'starlight_timber', quantity: 2 }],
        outputItemId: 'starlight_staff',
        outputQuantity: 1,
        animaCost: 20,
        xp: 420,
        intervalSeconds: 6.2,
    },
    attune_ward_scroll: {
        id: 'attune_ward_scroll',
        skill: 'attunement',
        levelReq: 85,
        name: 'Ward Scroll',
        inputs: [{ itemId: 'voidweave_bolt', quantity: 1 }],
        outputItemId: 'ward_scroll',
        outputQuantity: 1,
        animaCost: 30,
        xp: 650,
        intervalSeconds: 7.5,
    },
    // --- ATTUNEMENT: SKILLING & COMBAT AURAS ---
    craft_lesser_aura_quarry: {
        id: 'craft_lesser_aura_quarry',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Deep Quarry',
        animaCost: 25,
        inputs: [{ itemId: 'ashwood_timber', quantity: 3 }, { itemId: 'pyrite_ore', quantity: 2 }],
        outputItemId: 'lesser_aura_quarry',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_quarry: {
        id: 'craft_greater_aura_quarry',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Deep Quarry',
        animaCost: 60,
        inputs: [{ itemId: 'galena_ore', quantity: 2 }, { itemId: 'cold_iron_ore', quantity: 2 }],
        outputItemId: 'greater_aura_quarry',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_quarry: {
        id: 'craft_celestial_aura_quarry',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Deep Quarry',
        animaCost: 150,
        inputs: [{ itemId: 'solar_aurum_ore', quantity: 2 }, { itemId: 'titan_shard', quantity: 1 }],
        outputItemId: 'celestial_aura_quarry',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_woods: {
        id: 'craft_lesser_aura_woods',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Whispering Woods',
        animaCost: 25,
        inputs: [{ itemId: 'ashwood_timber', quantity: 3 }, { itemId: 'whispering_oak', quantity: 2 }],
        outputItemId: 'lesser_aura_woods',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_woods: {
        id: 'craft_greater_aura_woods',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Whispering Woods',
        animaCost: 60,
        inputs: [{ itemId: 'weeping_willow', quantity: 2 }, { itemId: 'bloodwood_timber', quantity: 2 }],
        outputItemId: 'greater_aura_woods',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_woods: {
        id: 'craft_celestial_aura_woods',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Whispering Woods',
        animaCost: 150,
        inputs: [{ itemId: 'ghostwood_timber', quantity: 2 }, { itemId: 'starlight_timber', quantity: 1 }],
        outputItemId: 'celestial_aura_woods',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_tide: {
        id: 'craft_lesser_aura_tide',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Abyssal Tide',
        animaCost: 25,
        inputs: [{ itemId: 'ashwood_timber', quantity: 3 }, { itemId: 'pyrite_ore', quantity: 2 }],
        outputItemId: 'lesser_aura_tide',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_tide: {
        id: 'craft_greater_aura_tide',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Abyssal Tide',
        animaCost: 60,
        inputs: [{ itemId: 'bog_pearl', quantity: 2 }, { itemId: 'cairn_sigil', quantity: 2 }],
        outputItemId: 'greater_aura_tide',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_tide: {
        id: 'craft_celestial_aura_tide',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Abyssal Tide',
        animaCost: 150,
        inputs: [{ itemId: 'rimefang', quantity: 2 }, { itemId: 'draconic_scale', quantity: 1 }],
        outputItemId: 'celestial_aura_tide',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_bloom: {
        id: 'craft_lesser_aura_bloom',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Verdant Bloom',
        animaCost: 25,
        inputs: [{ itemId: 'earthtuber', quantity: 3 }, { itemId: 'ashwood_timber', quantity: 2 }],
        outputItemId: 'lesser_aura_bloom',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_bloom: {
        id: 'craft_greater_aura_bloom',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Verdant Bloom',
        animaCost: 60,
        inputs: [{ itemId: 'glowshroom', quantity: 2 }, { itemId: 'deep_radish', quantity: 2 }],
        outputItemId: 'greater_aura_bloom',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_bloom: {
        id: 'craft_celestial_aura_bloom',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Verdant Bloom',
        animaCost: 150,
        inputs: [{ itemId: 'bramble_mandrake', quantity: 2 }, { itemId: 'sunfire_pepper', quantity: 1 }],
        outputItemId: 'celestial_aura_bloom',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_herbarium: {
        id: 'craft_lesser_aura_herbarium',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Wild Herbarium',
        animaCost: 25,
        inputs: [{ itemId: 'silverleaf', quantity: 3 }, { itemId: 'ashwood_timber', quantity: 2 }],
        outputItemId: 'lesser_aura_herbarium',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_herbarium: {
        id: 'craft_greater_aura_herbarium',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Wild Herbarium',
        animaCost: 60,
        inputs: [{ itemId: 'nightshade_bell', quantity: 2 }, { itemId: 'wyrmfrond', quantity: 2 }],
        outputItemId: 'greater_aura_herbarium',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_herbarium: {
        id: 'craft_celestial_aura_herbarium',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Wild Herbarium',
        animaCost: 150,
        inputs: [{ itemId: 'solar_remnant', quantity: 2 }, { itemId: 'primordial_ember', quantity: 1 }],
        outputItemId: 'celestial_aura_herbarium',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_shadow: {
        id: 'craft_lesser_aura_shadow',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Shadow Step',
        animaCost: 25,
        inputs: [{ itemId: 'mire_rat_pelt', quantity: 3 }, { itemId: 'pyrite_ore', quantity: 2 }],
        outputItemId: 'lesser_aura_shadow',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_shadow: {
        id: 'craft_greater_aura_shadow',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Shadow Step',
        animaCost: 60,
        inputs: [{ itemId: 'ghoul_hide', quantity: 2 }, { itemId: 'crypt_carapace', quantity: 2 }],
        outputItemId: 'greater_aura_shadow',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_shadow: {
        id: 'craft_celestial_aura_shadow',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Shadow Step',
        animaCost: 150,
        inputs: [{ itemId: 'dreadclaw', quantity: 2 }, { itemId: 'void_ichor', quantity: 1 }],
        outputItemId: 'celestial_aura_shadow',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_forge: {
        id: 'craft_lesser_aura_forge',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Eternal Flame',
        animaCost: 25,
        inputs: [{ itemId: 'pyrite_ore', quantity: 3 }, { itemId: 'dawnburn_ingot', quantity: 2 }],
        outputItemId: 'lesser_aura_forge',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_forge: {
        id: 'craft_greater_aura_forge',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Eternal Flame',
        animaCost: 60,
        inputs: [{ itemId: 'cold_iron_ingot', quantity: 2 }, { itemId: 'steel_ingot', quantity: 2 }],
        outputItemId: 'greater_aura_forge',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_forge: {
        id: 'craft_celestial_aura_forge',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Eternal Flame',
        animaCost: 150,
        inputs: [{ itemId: 'solar_aurum_ingot', quantity: 2 }, { itemId: 'astralite_ingot', quantity: 1 }],
        outputItemId: 'celestial_aura_forge',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_hearth: {
        id: 'craft_lesser_aura_hearth',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Hearthfire',
        animaCost: 25,
        inputs: [{ itemId: 'earthtuber', quantity: 3 }, { itemId: 'ashwood_timber', quantity: 2 }],
        outputItemId: 'lesser_aura_hearth',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_hearth: {
        id: 'craft_greater_aura_hearth',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Hearthfire',
        animaCost: 60,
        inputs: [{ itemId: 'glowshroom', quantity: 2 }, { itemId: 'deep_radish', quantity: 2 }],
        outputItemId: 'greater_aura_hearth',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_hearth: {
        id: 'craft_celestial_aura_hearth',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Hearthfire',
        animaCost: 150,
        inputs: [{ itemId: 'cinder_core', quantity: 2 }, { itemId: 'wyrm_ember', quantity: 1 }],
        outputItemId: 'celestial_aura_hearth',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_fletcher: {
        id: 'craft_lesser_aura_fletcher',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Master Fletcher',
        animaCost: 25,
        inputs: [{ itemId: 'ashwood_timber', quantity: 3 }, { itemId: 'whispering_oak', quantity: 2 }],
        outputItemId: 'lesser_aura_fletcher',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_fletcher: {
        id: 'craft_greater_aura_fletcher',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Master Fletcher',
        animaCost: 60,
        inputs: [{ itemId: 'weeping_willow', quantity: 2 }, { itemId: 'bloodwood_timber', quantity: 2 }],
        outputItemId: 'greater_aura_fletcher',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_fletcher: {
        id: 'craft_celestial_aura_fletcher',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Master Fletcher',
        animaCost: 150,
        inputs: [{ itemId: 'ghostwood_timber', quantity: 2 }, { itemId: 'starlight_timber', quantity: 1 }],
        outputItemId: 'celestial_aura_fletcher',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_alchemy: {
        id: 'craft_lesser_aura_alchemy',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Philosopher',
        animaCost: 25,
        inputs: [{ itemId: 'silverleaf', quantity: 3 }, { itemId: 'pyrite_ore', quantity: 2 }],
        outputItemId: 'lesser_aura_alchemy',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_alchemy: {
        id: 'craft_greater_aura_alchemy',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Philosopher',
        animaCost: 60,
        inputs: [{ itemId: 'nightshade_bell', quantity: 2 }, { itemId: 'bog_pearl', quantity: 2 }],
        outputItemId: 'greater_aura_alchemy',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_alchemy: {
        id: 'craft_celestial_aura_alchemy',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Philosopher',
        animaCost: 150,
        inputs: [{ itemId: 'wyrmfrond', quantity: 2 }, { itemId: 'primordial_ember', quantity: 1 }],
        outputItemId: 'celestial_aura_alchemy',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_sculptor: {
        id: 'craft_lesser_aura_sculptor',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Rune Sculptor',
        animaCost: 25,
        inputs: [{ itemId: 'homespun_bolt', quantity: 3 }, { itemId: 'pyrite_ore', quantity: 2 }],
        outputItemId: 'lesser_aura_sculptor',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_sculptor: {
        id: 'craft_greater_aura_sculptor',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Rune Sculptor',
        animaCost: 60,
        inputs: [{ itemId: 'silk_bolt', quantity: 2 }, { itemId: 'cairn_sigil', quantity: 2 }],
        outputItemId: 'greater_aura_sculptor',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_sculptor: {
        id: 'craft_celestial_aura_sculptor',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Rune Sculptor',
        animaCost: 150,
        inputs: [{ itemId: 'gilded_bolt', quantity: 2 }, { itemId: 'voidweave_bolt', quantity: 1 }],
        outputItemId: 'celestial_aura_sculptor',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_cosmos: {
        id: 'craft_lesser_aura_cosmos',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Cosmic Resonance',
        animaCost: 25,
        inputs: [{ itemId: 'pyrite_ore', quantity: 3 }, { itemId: 'ashwood_timber', quantity: 2 }],
        outputItemId: 'lesser_aura_cosmos',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_cosmos: {
        id: 'craft_greater_aura_cosmos',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Cosmic Resonance',
        animaCost: 60,
        inputs: [{ itemId: 'cut_celestial_gem', quantity: 2 }, { itemId: 'whispering_oak', quantity: 2 }],
        outputItemId: 'greater_aura_cosmos',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_cosmos: {
        id: 'craft_celestial_aura_cosmos',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Cosmic Resonance',
        animaCost: 150,
        inputs: [{ itemId: 'crypt_relic_fragment', quantity: 2 }, { itemId: 'starlight_timber', quantity: 1 }],
        outputItemId: 'celestial_aura_cosmos',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_vanguard: {
        id: 'craft_lesser_aura_vanguard',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Vanguard',
        animaCost: 25,
        inputs: [{ itemId: 'dawnburn_ingot', quantity: 3 }, { itemId: 'mire_rat_pelt', quantity: 2 }],
        outputItemId: 'lesser_aura_vanguard',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_vanguard: {
        id: 'craft_greater_aura_vanguard',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Vanguard',
        animaCost: 60,
        inputs: [{ itemId: 'steel_ingot', quantity: 2 }, { itemId: 'ossuary_bone', quantity: 2 }],
        outputItemId: 'greater_aura_vanguard',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_vanguard: {
        id: 'craft_celestial_aura_vanguard',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Vanguard',
        animaCost: 150,
        inputs: [{ itemId: 'solar_aurum_ingot', quantity: 2 }, { itemId: 'dreadclaw', quantity: 1 }],
        outputItemId: 'celestial_aura_vanguard',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_windrunner: {
        id: 'craft_lesser_aura_windrunner',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Windrunner',
        animaCost: 25,
        inputs: [{ itemId: 'ashwood_timber', quantity: 3 }, { itemId: 'mire_rat_pelt', quantity: 2 }],
        outputItemId: 'lesser_aura_windrunner',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_windrunner: {
        id: 'craft_greater_aura_windrunner',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Windrunner',
        animaCost: 60,
        inputs: [{ itemId: 'weeping_willow', quantity: 2 }, { itemId: 'frost_worg_fur', quantity: 2 }],
        outputItemId: 'greater_aura_windrunner',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_windrunner: {
        id: 'craft_celestial_aura_windrunner',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Windrunner',
        animaCost: 150,
        inputs: [{ itemId: 'starlight_timber', quantity: 2 }, { itemId: 'drake_leather', quantity: 1 }],
        outputItemId: 'celestial_aura_windrunner',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_arcane: {
        id: 'craft_lesser_aura_arcane',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Arcane Weave',
        animaCost: 25,
        inputs: [{ itemId: 'homespun_bolt', quantity: 3 }, { itemId: 'silverleaf', quantity: 2 }],
        outputItemId: 'lesser_aura_arcane',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_arcane: {
        id: 'craft_greater_aura_arcane',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Arcane Weave',
        animaCost: 60,
        inputs: [{ itemId: 'silk_bolt', quantity: 2 }, { itemId: 'nightshade_bell', quantity: 2 }],
        outputItemId: 'greater_aura_arcane',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_arcane: {
        id: 'craft_celestial_aura_arcane',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Arcane Weave',
        animaCost: 150,
        inputs: [{ itemId: 'voidweave_bolt', quantity: 2 }, { itemId: 'gazing_eye', quantity: 1 }],
        outputItemId: 'celestial_aura_arcane',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_aegis: {
        id: 'craft_lesser_aura_aegis',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Aegis',
        animaCost: 25,
        inputs: [{ itemId: 'dawnburn_ingot', quantity: 3 }, { itemId: 'pyrite_ore', quantity: 2 }],
        outputItemId: 'lesser_aura_aegis',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_aegis: {
        id: 'craft_greater_aura_aegis',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Aegis',
        animaCost: 60,
        inputs: [{ itemId: 'steel_ingot', quantity: 2 }, { itemId: 'crypt_carapace', quantity: 2 }],
        outputItemId: 'greater_aura_aegis',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_aegis: {
        id: 'craft_celestial_aura_aegis',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Aegis',
        animaCost: 150,
        inputs: [{ itemId: 'astralite_ingot', quantity: 2 }, { itemId: 'titan_core', quantity: 1 }],
        outputItemId: 'celestial_aura_aegis',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
    craft_lesser_aura_vitality: {
        id: 'craft_lesser_aura_vitality',
        skill: 'attunement',
        levelReq: 15,
        name: 'Lesser Aura of Vitality',
        animaCost: 25,
        inputs: [{ itemId: 'earthtuber', quantity: 3 }, { itemId: 'ashwood_timber', quantity: 2 }],
        outputItemId: 'lesser_aura_vitality',
        outputQuantity: 1,
        xp: 35,
        intervalSeconds: 4.0,
    },
    craft_greater_aura_vitality: {
        id: 'craft_greater_aura_vitality',
        skill: 'attunement',
        levelReq: 45,
        name: 'Greater Aura of Vitality',
        animaCost: 60,
        inputs: [{ itemId: 'deep_radish', quantity: 2 }, { itemId: 'cinder_core', quantity: 2 }],
        outputItemId: 'greater_aura_vitality',
        outputQuantity: 1,
        xp: 110,
        intervalSeconds: 5.5,
    },
    craft_celestial_aura_vitality: {
        id: 'craft_celestial_aura_vitality',
        skill: 'attunement',
        levelReq: 75,
        name: 'Celestial Aura of Vitality',
        animaCost: 150,
        inputs: [{ itemId: 'sunfire_pepper', quantity: 2 }, { itemId: 'leviathan_scale', quantity: 1 }],
        outputItemId: 'celestial_aura_vitality',
        outputQuantity: 1,
        xp: 350,
        intervalSeconds: 7.0,
    },
};
//# sourceMappingURL=recipes.js.map